import * as _ from 'lodash';
import $, { param } from 'jquery';
import { format } from 'date-fns';
import { SharedHttpClientService } from './../../../Shared/Services/shared-http-client.service';
import { UrlsService } from './../../../Shared/Services/urls.service';
import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectorRef, ViewContainerRef, ElementRef, viewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { GridService } from '../../../Shared/Services/grid.service';
import { UserService } from '../../../Shared/Services/user.service';
import {default as GridColumnsJSON} from './CAIS-FDID-Grid-Columns.json';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DataService } from 'app/Shared/Services/data.service';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { CaisServiceService } from '../cais-service.service';
import { CaisExceptionServiceService } from '../exceptions/cais-exception-service.service';
import { Table, TableModule } from 'primeng/table';
import { map } from 'rxjs/operators';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { ButtonModule } from 'primeng/button';
import { LowerCasePipe, NgClass, CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { DialogModule } from 'primeng/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatListItem } from '@angular/material/list';
import { FormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TidGeneratorComponent } from '../cais-tid/tid-generator/tid-generator.component';
import { CAISCustomerSearchComponent } from '../shared-component/cais-customer-search/cais-customer-search.component';
import { CAISAuditTrailDialogComponent } from '../shared-component/cais-audit-trail/cais-audit-trail-dialog.component';
import { QuickSearchComponent } from "app/Shared/Component/quick-search/quick-search.component";
import { ViewComponent } from '../shared-component/view/view.component';
import { ToastModule } from 'primeng/toast';
import { ActivatedRoute } from '@angular/router';
import { Select } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TabsModule } from 'primeng/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';


@Component({
    selector: 'app-cais-fdid',
    imports: [TableModule, FilterPanelComponent, ButtonModule, NgClass, MatProgressSpinner, CommonModule, ExportToCSVSComponent,
        DialogModule, MatDividerModule, MatListItem, Select, FormsModule, DatePickerModule, MultiSelectModule, ConfirmDialogModule,
        TidGeneratorComponent, LowerCasePipe, CAISCustomerSearchComponent, CAISAuditTrailDialogComponent, QuickSearchComponent,
        ViewComponent, ToggleSwitchModule, ToastModule, TabsModule, MatTooltipModule],
    templateUrl: './cais-fdid.component.html',
    styleUrls: ['./cais-fdid.component.scss']
})
export class CAISFDIDComponent implements OnInit, OnDestroy {
  @ViewChild(('dt')) dt!: Table;
  tabs:any[]=[];
  date!: Date 
  quickFilterArray: any = GridColumnsJSON["CAIS-FDID-Quick-Search-Fields"];
  GridColumns = GridColumnsJSON["CAISFDIDCols"];
  CAISFDIDCSVGridColumns: any;
  AddressGridColumns: any = GridColumnsJSON["AddressesDataCols"];
  NaturalPersonGridColumns:any = GridColumnsJSON["CAISNaturalPersonCols"];
  LegalEntityGridColumns:any = GridColumnsJSON["CAISLegalEntityCols"];
  LTIDGridColumns:any = GridColumnsJSON["CAISLTIDCols"];
  TIDGridColumns:any = GridColumnsJSON["CAISTIDCols"];
  activeRecordType: string = 'STAGING';
  dataset: any[] = [];
  LTIDDataSet: any[] = [{largeTraderID: '', ltidEffectiveDate: '', ltidEndDate: '', ltidEndReason: ''}];
  ApplicationName: any = '';
  LastExecutionDate!: any[];
  quickFilterEventType: any;
  quickFilterEventTypeArray: any = [];
  DefaultFilterArray: any = [];
  isLoadingResults = true;
  isAddLoadingResults = true;
  isEditLoadingResults = true;
  isViewLoadingResults = true;
  addScreenNegotiatedFields: Array<string> = ['Fdid Record ID','Id', 'Action', 'Firm', 'FDID Action', 'Active', 'Report Date', 'Report Reason', 'Is Natural Person', 'File ID', 'Init Finra Status', 'Init Finra Submission File Name', 'Initial Finra Submission Date', 'Initial Finra Feedback Date', 'Last Finra Status', 'Last Finra Submission File Name', 'Last Finra Submission Date', 'Last Finra Feedback DateTime', 'Updated Date', 'Updated User', 'Created Date', 'Created User'];
  editScreenNegotiatedFields: Array<string> = ['Fdid Record ID','Id', 'Action', 'Firm', 'FDID Action', 'Active', 'Report Date', 'Report Reason', 'Is Natural Person', 'File ID', 'Init Finra Status', 'Init Finra Submission File Name', 'Initial Finra Submission Date', 'Initial Finra Feedback Date', 'Last Finra Status', 'Last Finra Submission File Name', 'Last Finra Submission Date', 'Last Finra Feedback DateTime', 'Updated Date', 'Updated User', 'Created Date', 'Created User'];
  viewScreenNegotiatedFields: Array<string> = ['Fdid Record ID','Id', 'Action', 'Firm', 'FDID Action', 'Active', 'Is Natural Person', 'File ID', 'Init Finra Status', 'Init Finra Submission File Name', 'Initial Finra Submission Date', 'Initial Finra Feedback Date', 'Last Finra Status', 'Last Finra Submission File Name', 'Last Finra Submission Date', 'Last Finra Feedback DateTime', 'Updated Date', 'Updated User', 'Created Date', 'Created User'];
  CommonNegotiatedFields: Array<string> = ['File ID'];
  DisabledFields: Array<string> = ['Role End Date', 'Role End Reason'];
  editDisabledFields: Array<string> = ['Received FDID', 'TID Value'];
  editabledCaisCorrectionFields: Array<string> = ['EIN', 'LEI','TID Type', 'Foreign TID Type','Foreign TID Country','TID Value'];
  ExceptionalFDIDScreenFields: Array<string> = ['Customer Type', 'Role', 'Has Discretion', 'Role Start Date', 'TID Type', 'Foreign TID Type', 'Role End Date', 'Role End Reason', 'Customer Record ID', 'In Customer Record ID', 'Foreign TID Country', 'TID Value', 'Rep By TID Type', 'Rep by Foreign TID Type', 'Replacing Foreign TID Country', 'Rep By TID Value'];
  CountryFields: Array<string> = ['Foreign TID Country', 'Replacing Foreign TID Country'];
  yearField: any = ['Year Of Birth'];
  FutureRestrictedFields: Array<string> = ['FDID Date', 'Role Start Date'];
  Limit: any = { 'Start': '', 'End': '' };
  previousLimit: any = { 'Start': '', 'End': '' };
  rowsPerPageOptions: any = [];
  totalRecords!: number;
  rowcount!: number;
  startLimit: any = 0;
  endLimit!: number;
  tbldatamsg = 'L o a d i n g . . . . .';
  cols: any = [];
  filterCols: any = [];
  NaturalPersoncols: any = [];
  LegalEntitycols: any = [];
  LTIDcols: any = [];
  TIDcols: any = [];
  selectedRow: any = [];
  pageNumber: any = 1;
  priviousStartLimit: any;
  rowDataforDialog: any = [];
  rowIndexForDialog: number | undefined;
  actionType!: string;
  subscription: any;
  sortData: any = { field: '', order: 0 };
  sortClickCounter: number = 0;
  defaultData: any;
  addressColumns: any = [];
  addressColumnJson: any = [];
  FDIDScreenDataDetails: any = [];
  FDIDAddressDetails: any = [];
  NaturalPersonDataDetails: any = [];
  LegalEntityDataDetails: any = [];
  AddressDetails: any = [];
  NaturalPersonAddressDetails: any = [];
  LegalEntityAddressDetails: any = [];
  screenDataDetails: any = [];
  NaturalPersonScreenDataDetails: any = [];
  LegalEntityScreenDataDetails: any = [];
  LTIDScreenDataDetails: any = [];
  TIDScreenDataDetails: any = [];
  Add: boolean = false;
  Edit: boolean = false;
  View: boolean = false;
  screenType: string = "CAIS-FDID";
  isClickedOnce: boolean = false;
  storeBirthYear: any = [];
  NaturalPersons: any[] = [{id: 0, name: 'Add Natural Person'}];
  LegalEntities: any[] = [{id: 0, name: 'Add Legal Entity'}];
  removedCustomers: any[] = [];
  TIDUpdatedTabIndexes: any = [];
  selectedTabIndex: number = 0;
  selectedCustomerType!: string;
  userPreEncoded: string = '';
  userPostEncoded: string = '';
  maximumDateTime: any = new Date();
  isAuditTrail!: boolean;
  NPTIDSwitches: any = [];
  LETIDSwitches: any = [];
  addressColumnsAction: any = [];
  isClickOnTIDCorrection:boolean = false;
  isClickOnFDIDCorrection:boolean = false;
  catFDIDDetails:any;
  isCatFDIDAddDetails:boolean = false;
  isCatFDIDViewDetails:boolean = false;
  isCopyRecord:boolean=false;
  newtabIndex:number=0;

  constructor(private UserService: UserService,
    
    private urlService: UrlsService,
    private gridService: GridService,
    private messageService: MessageService,

    public confirmationService: ConfirmationService,
    public constantService: ConstantService,
    public dataService: DataService,
    private emitterService: EmitterService,
    private sortPipe: SortPipe,
    private sharedHttpClientService: SharedHttpClientService,
    private cdr: ChangeDetectorRef,
    public caisExceptionServiceService: CaisExceptionServiceService,
    public caisServiceService:CaisServiceService,
    private viewContainerRef: ViewContainerRef,
    private el: ElementRef,
    private route:ActivatedRoute,

  ) {
    this.cols = [];
    this.filterCols = [];
    this.ApplicationName = this.constantService.getApplicationName();
    this.UserService.CAISFDIDRecordType = this.activeRecordType;
    this.catFDIDDetails = [];
  }
   ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.endLimit = this.constantService.DEFAULT_ROWSIZE;
    this.Limit = { 'Start': '0', 'End': this.rowcount };
    this.rowsPerPageOptions = this.constantService.DEFAULT_ROWSPERPAGEOPTION;
    this.dataset = [];
    this.totalRecords = this.rowcount;
    this.quickFilterEventTypeArray = this.gridService.eventTypes;
    this.defaultFilter();

    this.getColumns();
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe({
      next: (value:any) => {
      if (value) {
        this.getData();
      }
    }});
    this.isClickOnTIDCorrection = false;
    this.isClickOnFDIDCorrection =false;
    this.route.queryParams.subscribe(param => {
      if (Object.keys(param).length > 0) {
        let urlEncodedParams: object | any = new Object();
        urlEncodedParams = JSON.parse(atob((param['FDIDData'])));
        this.catFDIDDetails = urlEncodedParams;
        if(param['mode'] === 'Add'){
        this.isCatFDIDAddDetails =true;
        this.actionType = "Add";
        this.onRowSelect('Add');
        }
        else if (param['mode'] === 'View'){
          this.isCatFDIDViewDetails = true;
          this.actionType = "Edit";
          this.onRowSelect('Edit',0,this.catFDIDDetails);
        }
      }
    })
  }

  updateDefaultArray($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;

    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;
    this.dt.first = 1; // Reset Selected Page to Initial Page

    this.getData();
  }

  clearQuickSearch($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;

    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;
    this.dt.first = 1; // Reset Selected Page to Initial Page

    this.getData();
  }

  closeDialog(value: any) {
    if (value) {
      this.dataService.roeSelectedRecords = [];
      this.getData();
    }
    this.Add = false;
    this.Edit = false;
    this.View = false;
    this.isCatFDIDAddDetails = false;
    this.isCatFDIDViewDetails = false;
    this.isCopyRecord = false;    
    this.isClickOnFDIDCorrection =false;
  }

  getColumns() {
    let csvGridColumns = this.GridColumns;
    this.CAISFDIDCSVGridColumns = csvGridColumns.filter((gridColObj: any) => !gridColObj?.isOptionalFields && !_.includes(['Action'], gridColObj?.ui_columnname)); // Receiving Only Mandatory Fields and Ignoring Optional Fields

    let column: any;
    column = this.GridColumns;
    if (column !== null || column !== undefined) {
      this.cols = this.gridService.getGridColumns(column);
      this.filterCols = this.cols;
    }

    let addressColumn: any = this.AddressGridColumns;

    this.addressColumnJson = [];
    if (addressColumn != null || addressColumn != undefined) {
      this.addressColumnsAction = this.gridService.getGridColumns(addressColumn);
      // removed Action column from FDID section
      this.addressColumns = this.gridService.getGridColumns(addressColumn);

      /* Adding Country & Region Code Menus */
      if(this.addressColumns.length > 0) {
        for(let i=0; i < this.addressColumns.length; i++) {
          if(this.addressColumns[i]["header"] === "Country Code") {
            this.addressColumns[i]["dropdownvalue"] = this.UserService.countryList;
          } else if(this.addressColumns[i]["header"] === "Region Code") {
            this.addressColumns[i]["dropdownvalue"] = this.UserService.countryRegionList;
          }
        }
      } 
      
      if(this.addressColumnsAction.length > 0) {        
        for(let i=0; i < this.addressColumnsAction.length; i++) {
          if(this.addressColumnsAction[i]["header"] === "Country Code") {
            this.addressColumnsAction[i]["dropdownvalue"] = this.UserService.countryList;
          } else if(this.addressColumnsAction[i]["header"] === "Region Code") {
            this.addressColumnsAction[i]["dropdownvalue"] = this.UserService.countryRegionList;
          }
        }
      } 

    }

    /* Natural Person Grid Fields */
    let NaturalPersoncolumn: any;
    NaturalPersoncolumn = this.NaturalPersonGridColumns;
    if (NaturalPersoncolumn !== null || NaturalPersoncolumn !== undefined) {
      this.NaturalPersoncols = this.gridService.getGridColumns(NaturalPersoncolumn);
    }
    /* End of Natural Person Grid Fields */

    let LegalEntitycolumn: any;
    LegalEntitycolumn = this.LegalEntityGridColumns;
    if (LegalEntitycolumn !== null || LegalEntitycolumn !== undefined) {
      this.LegalEntitycols = this.gridService.getGridColumns(LegalEntitycolumn);
    }

    let LTIDcolumn: any;
    LTIDcolumn = this.LTIDGridColumns;
    if (LTIDcolumn !== null || LTIDcolumn !== undefined) {
      this.LTIDcols = this.gridService.getGridColumns(LTIDcolumn);
    }

    let TIDcolumn: any;
    TIDcolumn = this.TIDGridColumns;
    if (TIDcolumn !== null || TIDcolumn !== undefined) {
      this.TIDcols = this.gridService.getGridColumns(TIDcolumn);
    }

  }

  maskYear() {
    let birthYears = (this.storeBirthYear && this.storeBirthYear.length > 0 ? this.storeBirthYear : []);
    $(() => {
      $('.birthYear').each(function(index: string | number) {
          const yearOfBirthElement = $('#yearOfBirth' + index);
          const yearOfBirthValue = yearOfBirthElement.val();
          if(yearOfBirthValue && yearOfBirthValue.toString().length > 3 && !yearOfBirthValue.toString().includes("*")) {
            birthYears[index] = (yearOfBirthValue.toString());
          }
          if(yearOfBirthValue && yearOfBirthValue.toString().length > 3) {
            const yearField = yearOfBirthValue.toString();
            const maskedValue = yearField.substring(0, yearField.toString().length-2) + '*'.repeat(2);
            $('#yearOfBirth' + index).val(maskedValue);
          }
      });
      this.storeBirthYear = birthYears;
    });
  }

  unMaskYear(eventValue: any) {
    const birthYears = this.storeBirthYear;
    $(() => {
      $('.birthYear').each(function(index: string | number) {
        const yearOfBirthElement = $('#yearOfBirth' + index);
        const yearOfBirthValue = yearOfBirthElement.val();
        if(yearOfBirthValue && yearOfBirthValue.toString().length > 3) {
          $('#yearOfBirth' + index).val(birthYears[index]);
        }

      });
    });
  }

  getRecordTypeData(recordType: any) {
    let recordTypeIndex = this.DefaultFilterArray.findIndex((filterElem: { label: string; }) => filterElem.label === 'Record Type');
    this.DefaultFilterArray[recordTypeIndex].values = recordType;
    this.DefaultFilterArray = [...this.DefaultFilterArray];
    this.FilterApplyFilterEvent(this.DefaultFilterArray);
  }

  FilterApplyFilterEvent(event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;

    /* Set Record Type */
    let recordTypeIndex = this.DefaultFilterArray.findIndex((filterElem: { label: string; }) => filterElem.label === 'Record Type');
    this.activeRecordType = this.DefaultFilterArray[recordTypeIndex].values;
    this.UserService.CAISFDIDRecordType = this.DefaultFilterArray[recordTypeIndex].values;

    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;
    this.getData();
  }

  onRowSelect(action: any, index?: any, rowData?: Object) {
    this.isClickOnTIDCorrection = false;
    this.isClickOnFDIDCorrection = false;
    this.actionType = action;
    this.dataService.roeSelectedRecords = [];
    this.Edit = false;
    this.caisExceptionServiceService.isCaisView = false;
    this.getScreenData(rowData);
    if (action === 'Edit') {
      this.Edit = true;
      this.dataService.roeSelectedRecords[0] = (rowData);
      this.rowDataforDialog = rowData;
      this.rowIndexForDialog = index;
      /* Retrieve Relevant Additional Details */
        this.getEditAdditionalData();
      /* End of Retrieve Relevant Additional Details */
    } else if (action === 'View') {
      // this.View = true;
      this.dataService.roeSelectedRecords[0] = (rowData);
      this.rowDataforDialog = rowData;
      this.rowIndexForDialog = index;
      /* Retrieve Relevant Additional Details */
        // this.getViewAdditionalData();
      /* End of Retrieve Relevant Additional Details */
      this.caisExceptionServiceService.isCaisView = true;
    } else if (action == 'Add') {
      this.Add = true;
      this.rowDataforDialog = [];
      this.rowIndexForDialog = 0;
      /* Retrieve Relevant Additional Details */
        this.getAdditionalData();
      /* End of Retrieve Relevant Additional Details */
    } else if (action == 'AuditTrail') {
      this.isAuditTrail=true;
      this.dataService.roeSelectedRecords[0] = (rowData);
      this.rowDataforDialog = rowData;
    }
  }

  getScreenData(selectedRowDetail: any = {}) {

    /* Get all Address fields to Display */
    this.AddressGridColumns = _.sortBy(this.AddressGridColumns, 'sortOrder');
    this.AddressDetails = [];
    for (let i = 0; i < Object.keys(this.AddressGridColumns).length; i++) {
      this.AddressDetails.push({
        "ui_Field_Name": this.AddressGridColumns[i]["ui_columnname"],
        "field_Name": this.AddressGridColumns[i]["mappingkey"],
        "value": selectedRowDetail[this.AddressGridColumns[i]["db_columnname"]],
        "datatype": this.AddressGridColumns[i]["datatype"],
        "display": this.AddressGridColumns[i]["display"],
        "db_columnname": this.AddressGridColumns[i]["db_columnname"],
        "dropdown": this.AddressGridColumns[i]["dropdown"],
        "dropdowntype": this.AddressGridColumns[i]["dropdowntype"],
        "dropdownvalue": _.includes(this.CountryFields, this.AddressGridColumns[i]["ui_columnname"]) ? this.UserService.countryList : this.AddressGridColumns[i]["dropdownvalue"],
        "isDisable": this.AddressGridColumns[i]["disabled"],
        "placeholder": (this.AddressGridColumns[i]["placeholder"] ? this.AddressGridColumns[i]["placeholder"] : "Please Enter Value"),
        "maximumLength": (this.AddressGridColumns[i]["maxlength"] ? this.AddressGridColumns[i]["maxlength"] : ""),
        "isrequired": (this.AddressGridColumns[i]["isrequired"] ? this.AddressGridColumns[i]["isrequired"] : false),
        "regexpressions": (this.AddressGridColumns[i]["regexpressions"] ? this.AddressGridColumns[i]["regexpressions"] : ""),
        "isOptionalFields": (this.AddressGridColumns[i]["isOptionalFields"] ? this.AddressGridColumns[i]["isOptionalFields"] : false)
      });
    }

    /* Get all Non-Address fields to Display */
    this.GridColumns = _.sortBy(this.GridColumns, 'sortOrder');

    this.screenDataDetails = [];
    for (let i = 0; i < Object.keys(this.GridColumns).length; i++) {
      if(!(/Address Line|City|Region Code|Country Code|Postal Code/.test(this.GridColumns[i]["ui_columnname"]))) {
        this.screenDataDetails.push({
          "ui_Field_Name": this.GridColumns[i]["ui_columnname"],
          "field_Name": this.GridColumns[i]["mappingkey"],
          "value": (_.includes(['Add', 'Edit'], this.actionType) && _.includes(['FDID Action'], this.GridColumns[i]["ui_columnname"])) ? (_.includes(['Add'], this.actionType) ? 'ADD' : 'UPDATE') : (_.includes(['Array'], this.GridColumns[i]["datatype"]) ? _.split(selectedRowDetail[this.GridColumns[i]["db_columnname"]], '@') : selectedRowDetail[this.GridColumns[i]["db_columnname"]]),
          "datatype": this.GridColumns[i]["datatype"],
          "display": this.GridColumns[i]["display"],
          "db_columnname": this.GridColumns[i]["db_columnname"],
          "dropdown": this.GridColumns[i]["dropdown"],
          "dropdowntype": this.GridColumns[i]["dropdowntype"],
          "dropdownvalue": _.includes(this.CountryFields, this.GridColumns[i]["ui_columnname"]) ? this.UserService.countryList : (this.GridColumns[i]["dropdown"]==="YES" && this.UserService.CAIS_Field_Dictionary[this.GridColumns[i]["db_columnname"]] ? _.cloneDeep(this.UserService.CAIS_Field_Dictionary[this.GridColumns[i]["db_columnname"]]) : this.GridColumns[i]["dropdownvalue"]),
          "isDisable": (_.includes(['Add'], this.actionType) && _.includes(this.DisabledFields, this.GridColumns[i]["ui_columnname"])) ? true : (_.includes(['Edit'], this.actionType) && _.includes(this.DisabledFields, this.GridColumns[i]["ui_columnname"]) ? false : ((_.includes(['Edit'], this.actionType) && _.includes(this.editDisabledFields, this.GridColumns[i]["ui_columnname"])) ? true : this.GridColumns[i]["disabled"])),
          "placeholder": (this.GridColumns[i]["placeholder"] ? this.GridColumns[i]["placeholder"] : "Please Enter Value"),
          "maximumLength": (this.GridColumns[i]["maxlength"] ? this.GridColumns[i]["maxlength"] : ""),
          "isLargeField": (this.GridColumns[i]["isLargeFields"] ? this.GridColumns[i]["isLargeFields"] : false),
          "isrequired": (this.GridColumns[i]["isrequired"] ? this.GridColumns[i]["isrequired"] : false),
          "regexpressions": (this.GridColumns[i]["regexpressions"] ? this.GridColumns[i]["regexpressions"] : ""),
          "hasAlternativeField": (this.GridColumns[i]["hasAlternativeField"] ? this.GridColumns[i]["hasAlternativeField"] : false),
          "alternativeFields": (this.GridColumns[i]["alternativeFields"] ? this.GridColumns[i]["alternativeFields"] : ""),
          "isOptionalFields": (this.GridColumns[i]["isOptionalFields"] ? this.GridColumns[i]["isOptionalFields"] : false)
        });
      }
    }

    /* Get all Natural Person fields to Display */
    this.NaturalPersonGridColumns = _.sortBy(this.NaturalPersonGridColumns, 'sortOrder');
    this.NaturalPersonScreenDataDetails = [];
    for (let i = 0; i < Object.keys(this.NaturalPersonGridColumns).length; i++) {
      if(!(/Address Line|City|Region Code|Country Code|Postal Code/.test(this.NaturalPersonGridColumns[i]["ui_columnname"]))) {
        this.NaturalPersonScreenDataDetails.push({
          "ui_Field_Name": this.NaturalPersonGridColumns[i]["ui_columnname"],
          "field_Name": this.NaturalPersonGridColumns[i]["mappingkey"],
          "value": (_.includes(['Array'], this.NaturalPersonGridColumns[i]["datatype"]) ? _.split(selectedRowDetail[this.NaturalPersonGridColumns[i]["db_columnname"]], '@') : selectedRowDetail[this.NaturalPersonGridColumns[i]["db_columnname"]]),
          "datatype": this.NaturalPersonGridColumns[i]["datatype"],
          "display": this.NaturalPersonGridColumns[i]["display"],
          "db_columnname": this.NaturalPersonGridColumns[i]["db_columnname"],
          "dropdown": this.NaturalPersonGridColumns[i]["dropdown"],
          "dropdowntype": this.NaturalPersonGridColumns[i]["dropdowntype"],
          "dropdownvalue": _.includes(this.CountryFields, this.NaturalPersonGridColumns[i]["ui_columnname"]) ? this.UserService.countryList : ((this.NaturalPersonGridColumns[i]["dropdown"]==="YES" && this.UserService.CAIS_Field_Dictionary[this.NaturalPersonGridColumns[i]["db_columnname"]]) ? _.cloneDeep(this.UserService.CAIS_Field_Dictionary[this.NaturalPersonGridColumns[i]["db_columnname"]]) : this.NaturalPersonGridColumns[i]["dropdownvalue"]),
          "isDisable": (_.includes(['Add'], this.actionType) && _.includes(this.DisabledFields, this.NaturalPersonGridColumns[i]["ui_columnname"])) ? true : (_.includes(['Edit'], this.actionType) && _.includes(this.DisabledFields, this.NaturalPersonGridColumns[i]["ui_columnname"]) ? false : ((_.includes(['Edit'], this.actionType) && _.includes(this.editDisabledFields, this.NaturalPersonGridColumns[i]["ui_columnname"])) ? true : this.NaturalPersonGridColumns[i]["disabled"])),
          "placeholder": (this.NaturalPersonGridColumns[i]["placeholder"] ? this.NaturalPersonGridColumns[i]["placeholder"] : "Please Enter Value"),
          "maximumLength": (this.NaturalPersonGridColumns[i]["maxlength"] ? this.NaturalPersonGridColumns[i]["maxlength"] : ""),
          "isLargeField": (this.NaturalPersonGridColumns[i]["isLargeFields"] ? this.NaturalPersonGridColumns[i]["isLargeFields"] : false),
          "isrequired": (this.NaturalPersonGridColumns[i]["isrequired"] ? this.NaturalPersonGridColumns[i]["isrequired"] : false),
          "regexpressions": (this.NaturalPersonGridColumns[i]["regexpressions"] ? this.NaturalPersonGridColumns[i]["regexpressions"] : ""),
          "isOptionalFields": (this.NaturalPersonGridColumns[i]["isOptionalFields"] ? this.NaturalPersonGridColumns[i]["isOptionalFields"] : false)
        });
      }
    }
    /* Disabling TID Type Option */
      let NPTIDTypeObjIndex = this.NaturalPersonScreenDataDetails.findIndex((objElement: { ui_Field_Name: string; }) => objElement.ui_Field_Name === "TID Type");
      this.NaturalPersonScreenDataDetails[NPTIDTypeObjIndex]["dropdownvalue"].reduce(function (previousValue: any[], currentValue: { disabled: boolean; value: string; }) {
        currentValue.disabled = ((currentValue.value === 'EIN') ? true : false);
        previousValue.push(currentValue);
        return previousValue;
      }, []);
    /* End of Disabling TID Type Option */

    /* Get all Legal Entity fields to Display */
    this.LegalEntityGridColumns = _.sortBy(this.LegalEntityGridColumns, 'sortOrder');
    this.LegalEntityScreenDataDetails = [];
    for (let i = 0; i < Object.keys(this.LegalEntityGridColumns).length; i++) {
      if(!(/Address Line|City|Region Code|Country Code|Postal Code/.test(this.LegalEntityGridColumns[i]["ui_columnname"]))) {
        this.LegalEntityScreenDataDetails.push({
          "ui_Field_Name": this.LegalEntityGridColumns[i]["ui_columnname"],
          "field_Name": this.LegalEntityGridColumns[i]["mappingkey"],
          "value": (_.includes(['Array'], this.LegalEntityGridColumns[i]["datatype"]) ? _.split(selectedRowDetail[this.LegalEntityGridColumns[i]["db_columnname"]], '@') : selectedRowDetail[this.LegalEntityGridColumns[i]["db_columnname"]]),
          "datatype": this.LegalEntityGridColumns[i]["datatype"],
          "display": this.LegalEntityGridColumns[i]["display"],
          "db_columnname": this.LegalEntityGridColumns[i]["db_columnname"],
          "dropdown": this.LegalEntityGridColumns[i]["dropdown"],
          "dropdowntype": this.LegalEntityGridColumns[i]["dropdowntype"],
          "dropdownvalue": _.includes(this.CountryFields, this.LegalEntityGridColumns[i]["ui_columnname"]) ? this.UserService.countryList : ((this.LegalEntityGridColumns[i]["dropdown"]==="YES" && this.UserService.CAIS_Field_Dictionary[this.LegalEntityGridColumns[i]["db_columnname"]]) ? _.cloneDeep(this.UserService.CAIS_Field_Dictionary[this.LegalEntityGridColumns[i]["db_columnname"]]) : this.LegalEntityGridColumns[i]["dropdownvalue"]),
          "isDisable": (_.includes(['Add'], this.actionType) && _.includes(this.DisabledFields, this.LegalEntityGridColumns[i]["ui_columnname"])) ? true : (_.includes(['Edit'], this.actionType) && _.includes(this.DisabledFields, this.LegalEntityGridColumns[i]["ui_columnname"]) ? false : ((_.includes(['Edit'], this.actionType) && _.includes(this.editDisabledFields, this.LegalEntityGridColumns[i]["ui_columnname"])) ? true : this.LegalEntityGridColumns[i]["disabled"])),
          "placeholder": (this.LegalEntityGridColumns[i]["placeholder"] ? this.LegalEntityGridColumns[i]["placeholder"] : "Please Enter Value"),
          "maximumLength": (this.LegalEntityGridColumns[i]["maxlength"] ? this.LegalEntityGridColumns[i]["maxlength"] : ""),
          "isLargeField": (this.LegalEntityGridColumns[i]["isLargeFields"] ? this.LegalEntityGridColumns[i]["isLargeFields"] : false),
          "isrequired": (this.LegalEntityGridColumns[i]["isrequired"] ? this.LegalEntityGridColumns[i]["isrequired"] : false),
          "regexpressions": (this.LegalEntityGridColumns[i]["regexpressions"] ? this.LegalEntityGridColumns[i]["regexpressions"] : ""),
          "hasAlternativeField": (this.LegalEntityGridColumns[i]["hasAlternativeField"] ? this.LegalEntityGridColumns[i]["hasAlternativeField"] : false),
          "alternativeFields": (this.LegalEntityGridColumns[i]["alternativeFields"] ? this.LegalEntityGridColumns[i]["alternativeFields"] : ""),
          "isOptionalFields": (this.LegalEntityGridColumns[i]["isOptionalFields"] ? this.LegalEntityGridColumns[i]["isOptionalFields"] : false)
        });
      }
    }
    /* Disabling TID Type Option */
      let LETIDTypeObjIndex = this.LegalEntityScreenDataDetails.findIndex((objElement: { ui_Field_Name: string; }) => objElement.ui_Field_Name === "TID Type");
      this.LegalEntityScreenDataDetails[LETIDTypeObjIndex]["dropdownvalue"].reduce(function (previousValue: any[], currentValue: { disabled: boolean; value: string; }) {
        currentValue.disabled = ((currentValue.value === 'SSN/ITIN') ? true : false);
        previousValue.push(currentValue);
        return previousValue;
      }, []);
    /* End of Disabling TID Type Option */

    /* Get all LTID fields to Display */
    this.LTIDGridColumns = _.sortBy(this.LTIDGridColumns, 'sortOrder');
    this.LTIDScreenDataDetails = [];
    for (let i = 0; i < Object.keys(this.LTIDGridColumns).length; i++) {
      this.LTIDScreenDataDetails.push({
        "ui_Field_Name": this.LTIDGridColumns[i]["ui_columnname"],
        "field_Name": this.LTIDGridColumns[i]["mappingkey"],
        "value": selectedRowDetail[this.LTIDGridColumns[i]["db_columnname"]],
        "datatype": this.LTIDGridColumns[i]["datatype"],
        "display": this.LTIDGridColumns[i]["display"],
        "db_columnname": this.LTIDGridColumns[i]["db_columnname"],
        "dropdown": this.LTIDGridColumns[i]["dropdown"],
        "dropdowntype": this.LTIDGridColumns[i]["dropdowntype"],
        "dropdownvalue": (this.LTIDGridColumns[i]["dropdown"]==="YES" && this.UserService.CAIS_Field_Dictionary[this.LTIDGridColumns[i]["db_columnname"]] ? _.cloneDeep(this.UserService.CAIS_Field_Dictionary[this.LTIDGridColumns[i]["db_columnname"]]) : this.LTIDGridColumns[i]["dropdownvalue"]),
        "isDisable": this.LTIDGridColumns[i]["disabled"],
        "placeholder": (this.LTIDGridColumns[i]["placeholder"] ? this.LTIDGridColumns[i]["placeholder"] : "Please Enter Value"),
        "maximumLength": (this.LTIDGridColumns[i]["maxlength"] ? this.LTIDGridColumns[i]["maxlength"] : ""),
        "isrequired": (this.LTIDGridColumns[i]["isrequired"] ? this.LTIDGridColumns[i]["isrequired"] : false),
        "regexpressions": (this.LTIDGridColumns[i]["regexpressions"] ? this.LTIDGridColumns[i]["regexpressions"] : ""),
        "isOptionalFields": (this.LTIDGridColumns[i]["isOptionalFields"] ? this.LTIDGridColumns[i]["isOptionalFields"] : false)
      });
    }

  }

  getAdditionalData() {
    this.isAddLoadingResults = true;

    this.FDIDScreenDataDetails = [];
    this.FDIDAddressDetails = [];
    let tabIndex = 0;

    if (this.isCatFDIDAddDetails) {
      this.FDIDScreenDataDetails["accountName"] = this.catFDIDDetails.accountName;
      this.FDIDScreenDataDetails["accountNumber"] = this.catFDIDDetails.accountNumber;
      this.FDIDScreenDataDetails["receivedFDID"] = this.catFDIDDetails.receivedFDID;
      this.FDIDScreenDataDetails["firmDesignatedID"] = this.catFDIDDetails.firmDesignatedID;
    }
    
    /* FDID Initial Addresses */
    this.FDIDAddressDetails = [{'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''}];
    /* End of FDID Initial Addresses */
    this.LTIDDataSet = [{largeTraderID: '', ltidEffectiveDate: '', ltidEndDate: '', ltidEndReason: ''}];

    this.NaturalPersons = [{id: 0, name: 'Add Natural Person', tabIndex: tabIndex, tabType: this.constantService.customerTypes[0]}];
    this.NaturalPersonDataDetails = [];
    /* Natural Person Fields */
      let NaturalPersonFields = this.NaturalPersonScreenDataDetails.map((screnField: { field_Name: any; }) => screnField.field_Name);
      let NaturalPersonFieldsObj :any  = {};
      NaturalPersonFields.forEach((element: string | number) => {
        NaturalPersonFieldsObj[element] = '';
      });
      this.NaturalPersonDataDetails = [NaturalPersonFieldsObj];
    /* End of Natural Person Fields */
    this.NaturalPersonAddressDetails = [];
    /* Natural Person Initial Addresses */
      let NaturalPersonAddressData = [];
      NaturalPersonAddressData.push({
        'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''
      });
      this.NaturalPersonAddressDetails.push(NaturalPersonAddressData);
    /* End of Natural Person Initial Addresses */
    this.LegalEntities = [{id: 0, name: 'Add Legal Entity', tabIndex: this.NaturalPersons.length, tabType: this.constantService.customerTypes[1]}];
    this.LegalEntityDataDetails = [];
    /* Legal Entity Fields */
      let LegalEntityFields = this.LegalEntityScreenDataDetails.map((screenField: { field_Name: any; }) => screenField.field_Name);
      let LegalEntityFieldsObj:any = {};
      LegalEntityFields.forEach((element: string | number) => {
        LegalEntityFieldsObj[element] = '';
      });
      this.LegalEntityDataDetails = [LegalEntityFieldsObj];
    /* End of Natural Person Fields */
    this.LegalEntityAddressDetails = [];
    /* Legal Entity Initial Addresses */
      let LegalEntityAddressData = [];
      LegalEntityAddressData.push({
        'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''
      });
      this.LegalEntityAddressDetails.push(LegalEntityAddressData);
    /* End of Legal Entity Initial Addresses */
    this.selectedTabIndex = this.NaturalPersons.length;
    this.getSearchCustomerType(); // Receive Customer Type for Customer Search on the basis of Opted Tab Index
    
    this.isAddLoadingResults = false;
  }

  getEditAdditionalData() {
    this.FDIDScreenDataDetails = [];
    this.FDIDAddressDetails = [];
    this.LTIDDataSet = [{largeTraderID: '', ltidEffectiveDate: '', ltidEndDate: '', ltidEndReason: ''}];
    this.NaturalPersons = [];
    this.LegalEntities = [];
    this.NaturalPersonDataDetails = [];
    this.NaturalPersonAddressDetails = [];
    this.LegalEntityDataDetails = [];
    this.LegalEntityAddressDetails = [];
    this.TIDUpdatedTabIndexes = []; // Reset TID Updated Tabs
    this.isEditLoadingResults = true;
    this.isAddLoadingResults = true;
    this.NPTIDSwitches = [];
    this.LETIDSwitches = [];
    this.removedCustomers = [];
    let tabIndex=0;

    /* FDID View Detail */
      this.sharedHttpClientService.post(
        this.urlService.setAPIURl(
          APIURL.CAIS_FDID_View
        ), {
          type: this.DefaultFilterArray[1].values,
          CATReporterIMID: this.UserService.getActiveMPID(),
          accountNumber: this.rowDataforDialog["accountNumber"],
          receivedFDID: this.isCatFDIDViewDetails ? this.catFDIDDetails.firmDesignatedID : ((!this.rowDataforDialog["receivedFDID"] || this.rowDataforDialog["receivedFDID"].length == 0) ? this.rowDataforDialog["receivedFDID"] : this.rowDataforDialog["firmDesignatedID"]),
          customerRecordID: this.rowDataforDialog["customerRecordID"],
          user: this.UserService.getUserName(),
          userName: this.UserService.getUserFirstName()
        }
      ).subscribe({
        next: (element:any) => {
          let dataset: any = element;
          this.isEditLoadingResults = false;
          this.isAddLoadingResults = false;
          /* FDID Details */
          if (dataset.fdidDetails !== null) {
            Object.keys(dataset.fdidDetails).forEach((key) => {
              if(_.includes(['accountType'], key)) {
                dataset.fdidDetails[key] = _.split(dataset.fdidDetails[key], '@');
              }
            });
            this.FDIDScreenDataDetails = dataset.fdidDetails;
            if(this.isCopyRecord){
              this.isClickOnFDIDCorrection =true;
              this.FDIDScreenDataDetails["accountNumber"] = '';
              this.FDIDScreenDataDetails["receivedFDID"] = '';
              this.FDIDScreenDataDetails["firmDesignatedID"] = '';
            }
          }
          /* FDID Address Details */
          this.FDIDAddressDetails = [];
          if(Object.keys(dataset.fdidAddrDetails).length > 0) {
            for(let j=1; j<=4; j++) {
              let addressData={
                'addr_addrLine1': (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['addrLine1'] : ''),
                'addr_addrLine2': (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['addrLine2'] : ''),
                'addr_addrLine3': (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['addrLine3'] : ''),
                'addr_addrLine4': (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['addrLine4'] : ''),
                'addr_city': (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['city'] : ''),
                'addr_regionCode': (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['regionCode'] : ''),
                'addr_countryCode': (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['countryCode'] : ''),
                'addr_postalCode': (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['postalCode'] : '')
              }
              if(Object.values(addressData).some(value=>value && value.trim() !=='')){
                this.FDIDAddressDetails.push(addressData);
              }
            }
            /* Add a Blank Address Row if don't have any Addresses */
              if(this.FDIDAddressDetails.length === 0) {
                this.FDIDAddressDetails.push({
                    'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''
                });
              }
            /* End of Adding a Blank Address Row if don't have any Addresses */
          } else {
            this.FDIDAddressDetails.push({
              'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''
            });
          }
          /* LTID Details */
          this.LTIDDataSet = dataset.ltidDetails.length > 0 ? dataset.ltidDetails : [{largeTraderID: '', ltidEffectiveDate: '', ltidEndDate: '', ltidEndReason: ''}];
          /* Natural Person Details */
            /* Natural Person Fields */
              let NaturalPersonFields = this.NaturalPersonScreenDataDetails.map((screnField: { field_Name: any; }) => screnField.field_Name);
              let NaturalPersonFieldsObj: any = {};
              NaturalPersonFields.forEach((element: string | number) => {
                NaturalPersonFieldsObj[element] = '';
              });
            /* End of Natural Person Fields */
          /* Getting values from Muli-Choice & Date Type Fields */
            if (dataset.naturalPersonDetails.length > 0) {
              for(let i=0;i<dataset.naturalPersonDetails.length;i++) {
                /* Set TID Update Flags */
                  this.caisServiceService.setClonedCustomerTIDFlag(dataset.naturalPersonDetails[i], dataset.naturalPersonDetails); // Search & Set Cloned Customer Flag
                  if(_.includes(this.caisServiceService.TIDUpdateStatuses, dataset.naturalPersonDetails[i]['tidUpdate'])) {
                    this.TIDUpdatedTabIndexes.push((i+1));
                  }
                /* End of setting TID Update Flags */
                Object.keys(dataset.naturalPersonDetails[i]).forEach((key) => {
                  if(_.includes(['customerType'], key)) {
                    dataset.naturalPersonDetails[i][key] = _.split(dataset.naturalPersonDetails[i][key], '@');
                  }
                });
              }

              dataset.naturalPersonDetails = dataset.naturalPersonDetails;
            }
          /* End of getting values from Muli-Choice & Date Type Fields */
          this.NaturalPersonDataDetails = dataset.naturalPersonDetails.length > 0 ? [NaturalPersonFieldsObj, ...dataset.naturalPersonDetails] : [NaturalPersonFieldsObj];
          this.NaturalPersons = [{id: 0, name: 'Add Natural Person', tabIndex: tabIndex, tabType: this.constantService.customerTypes[0]}];
          /* Natural Person Initial Addresses */
            let NaturalPersonAddressData = [];
            NaturalPersonAddressData.push({
              'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''
            });
            this.NaturalPersonAddressDetails.push(NaturalPersonAddressData);
          /* End of Natural Person Initial Addresses */
          if(dataset.naturalPersonDetails.length > 0) {
            for(let i=0;i<dataset.naturalPersonDetails.length;i++) {
              const name = this.caisServiceService.getNaturalPersonTabName(dataset.naturalPersonDetails[i]['firstName'] 
                , dataset.naturalPersonDetails[i]['lastName'], dataset.naturalPersonDetails[i]['inCustomerRecordID']);
                tabIndex = tabIndex+1;
              this.NaturalPersons.push({
                id: (i+1),
                name: name,
                tabIndex: tabIndex,
                tabType: this.constantService.customerTypes[0]
              });
              /* Natural Person Address Details */
                let NaturalPersonAddressData = [];
                for(let j=1; j<=4; j++) {
                  let addressData={
                    'addr_addrLine1': dataset.naturalPersonDetails[i]['addr'+j+'_addrLine1'],
                    'addr_addrLine2': dataset.naturalPersonDetails[i]['addr'+j+'_addrLine2'],
                    'addr_addrLine3': dataset.naturalPersonDetails[i]['addr'+j+'_addrLine3'],
                    'addr_addrLine4': dataset.naturalPersonDetails[i]['addr'+j+'_addrLine4'],
                    'addr_city': dataset.naturalPersonDetails[i]['addr'+j+'_city'],
                    'addr_regionCode': dataset.naturalPersonDetails[i]['addr'+j+'_regionCode'],
                    'addr_countryCode': dataset.naturalPersonDetails[i]['addr'+j+'_countryCode'],
                    'addr_postalCode': dataset.naturalPersonDetails[i]['addr'+j+'_postalCode']
                  }
                  if(Object.values(addressData).some(value=>value && value.trim() !=='')){
                    NaturalPersonAddressData.push(addressData);
                  }
                }
                /* Add a Blank Address Row if don't have any Addresses */
                  if(NaturalPersonAddressData.length === 0) {
                    NaturalPersonAddressData.push({
                        'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''
                    });
                  }
                /* End of Adding a Blank Address Row if don't have any Addresses */
                this.NaturalPersonAddressDetails.push(NaturalPersonAddressData);
              /* End of Natural Person Address Details */
            }
          }
          /* Legal Entity Details */
            /* Legal Entity Fields */
              let LegalEntityFields = this.LegalEntityScreenDataDetails.map((screenField: { field_Name: any; }) => screenField.field_Name);
              let LegalEntityFieldsObj:any = {};
              LegalEntityFields.forEach((element: string | number) => {
                LegalEntityFieldsObj[element] = '';
              });
            /* End of Legal Entity Fields */
          /* Getting values from Muli-Choice & Date Type Fields */
            if (dataset.legalEntityDetails.length > 0) {
              for(let i=0;i<dataset.legalEntityDetails.length;i++) {
                /* Set TID Update Flags */
                  this.caisServiceService.setClonedCustomerTIDFlag(dataset.legalEntityDetails[i], dataset.legalEntityDetails); // Search & Set Cloned Customer Flag
                  if(_.includes(this.caisServiceService.TIDUpdateStatuses, dataset.legalEntityDetails[i]['tidUpdate'])) {
                    this.TIDUpdatedTabIndexes.push(this.NaturalPersons.length + (i+1));
                  }
                /* End of setting TID Update Flags */
                Object.keys(dataset.legalEntityDetails[i]).forEach((key) => {
                  if(_.includes(['customerType'], key)) {
                    dataset.legalEntityDetails[i][key] = _.split(dataset.legalEntityDetails[i][key], '@');
                  }
                });
              }

              dataset.legalEntityDetails = dataset.legalEntityDetails;
            }
          /* End of getting values from Muli-Choice & Date Type Fields */
          this.LegalEntityDataDetails = dataset.legalEntityDetails.length > 0 ? [LegalEntityFieldsObj, ...dataset.legalEntityDetails] : [LegalEntityFieldsObj];
          tabIndex=this.NaturalPersons.length;
          this.LegalEntities = [{id: 0, name: 'Add Legal Entity', tabIndex: tabIndex, tabType: this.constantService.customerTypes[1]}];
          /* Legal Entity Initial Addresses */
            let LegalEntityAddressData = [];
            LegalEntityAddressData.push({
              'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''
            });
            this.LegalEntityAddressDetails.push(LegalEntityAddressData);
          /* End of Legal Entity Initial Addresses */
          if(dataset.legalEntityDetails.length > 0) {
            for(let i=0;i<dataset.legalEntityDetails.length;i++) {
              const legalEntityTabName = this.caisServiceService.getLegalEntityTabName(dataset.legalEntityDetails[i]['legalName'], dataset.legalEntityDetails[i]['inCustomerRecordID']);
              tabIndex=tabIndex+1;
              this.LegalEntities.push({
                id: (i+1),
                name: legalEntityTabName,
                tabIndex: tabIndex,
                tabType: this.constantService.customerTypes[1]
              });
              /* Legal Entity Address Details */
                let LegalEntityAddressData = [];
                for(let j=1; j<=4; j++) {
                  let addressData={
                    'addr_addrLine1': dataset.legalEntityDetails[i]['addr'+j+'_addrLine1'],
                    'addr_addrLine2': dataset.legalEntityDetails[i]['addr'+j+'_addrLine2'],
                    'addr_addrLine3': dataset.legalEntityDetails[i]['addr'+j+'_addrLine3'],
                    'addr_addrLine4': dataset.legalEntityDetails[i]['addr'+j+'_addrLine4'],
                    'addr_city': dataset.legalEntityDetails[i]['addr'+j+'_city'],
                    'addr_regionCode': dataset.legalEntityDetails[i]['addr'+j+'_regionCode'],
                    'addr_countryCode': dataset.legalEntityDetails[i]['addr'+j+'_countryCode'],
                    'addr_postalCode': dataset.legalEntityDetails[i]['addr'+j+'_postalCode']
                  }
                  if(Object.values(addressData).some(value=>value && value.trim() !=='')){
                    LegalEntityAddressData.push(addressData);
                  }
                }
                /* Add a Blank Address Row if don't have any Addresses */
                  if(LegalEntityAddressData.length === 0) {
                    LegalEntityAddressData.push({
                        'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''
                    });
                  }
                /* End of Adding a Blank Address Row if don't have any Addresses */
                this.LegalEntityAddressDetails.push(LegalEntityAddressData);
              /* End of Legal Entity Address Details */
            }
          }
          /* Mask Birth Date Field */
          if(this.yearField.length > 0) {
            this.maskYear();
          }
           this.selectedTabIndex = (this.LegalEntities.length > 1 ? (this.NaturalPersons.length + 1) : (this.NaturalPersons.length > 1 ? 1 : this.NaturalPersons.length));
           this.getSearchCustomerType(); // Receive Customer Type for Customer Search on the basis of Opted Tab Index
        }, error: (err: HttpErrorResponse) => {
          this.isEditLoadingResults = false;
          this.isAddLoadingResults = false;
      }});
    /* End of FDID View Detail */
  }

  getViewAdditionalData() {
    this.FDIDScreenDataDetails = [];
    this.FDIDAddressDetails = [];
    this.LTIDDataSet = [];
    this.NaturalPersons = [];
    this.LegalEntities = [];
    this.NaturalPersonDataDetails = [];
    this.NaturalPersonAddressDetails = [];
    this.LegalEntityDataDetails = [];
    this.LegalEntityAddressDetails = [];
    this.isViewLoadingResults = true;

    /* FDID View Detail */
      this.sharedHttpClientService.post(
        this.urlService.setAPIURl(
          APIURL.CAIS_FDID_View
        ), {
          type: this.DefaultFilterArray[1].values,
          CATReporterIMID: this.UserService.getActiveMPID(),
          accountNumber: this.rowDataforDialog["accountNumber"],
          receivedFDID: ((!this.rowDataforDialog["receivedFDID"] || this.rowDataforDialog["receivedFDID"].length == 0) ? this.rowDataforDialog["receivedFDID"] : this.rowDataforDialog["firmDesignatedID"]),
          customerRecordID: this.rowDataforDialog["customerRecordID"],
          user: this.UserService.getUserName(),
          userName: this.UserService.getUserFirstName()
        }
      ).subscribe({
        next: (element:any) => {
          let dataset: any = element;
          this.isViewLoadingResults = false;
          /* FDID Details */
          if (dataset.fdidDetails !== null) {
            this.FDIDScreenDataDetails = dataset.fdidDetails;
          } else {
            this.tbldatamsg = "No data found";
          }
          /* FDID Address Details */
          this.FDIDAddressDetails = [];
          if(Object.keys(dataset.fdidAddrDetails).length > 0) {
            for(let j=1; j<=4; j++) {
              /* Retrieve Country & Region Code */
              let countryCode, regionCountryCode;
              if(dataset.fdidAddrDetails[j-1]) {
                countryCode = _.find(this.UserService.countryList, {value:dataset.fdidAddrDetails[j-1]['countryCode']});
                regionCountryCode = _.find(this.UserService.countryRegionList, {value:dataset.fdidAddrDetails[j-1]['regionCode']});
              }
              let addressData={
                'addr_addrLine1': (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['addrLine1'] : ''),
                'addr_addrLine2': (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['addrLine2'] : ''),
                'addr_addrLine3': (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['addrLine3'] : ''),
                'addr_addrLine4': (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['addrLine4'] : ''),
                'addr_city': (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['city'] : ''),
                'addr_regionCode': (regionCountryCode ? regionCountryCode.label : (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['regionCode'] : '')),
                'addr_countryCode': (countryCode ? countryCode.label : (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['countryCode'] : '')),
                'addr_postalCode': (dataset.fdidAddrDetails[j-1] ? dataset.fdidAddrDetails[j-1]['postalCode'] : '')
              }
              if(Object.values(addressData).some(value=>value && value.trim() !=='')){
                this.FDIDAddressDetails.push(addressData);
              }
            }
          } else {
            this.FDIDAddressDetails.push({
              'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''
            });
          }
          /* LTID Details */
          this.LTIDDataSet = dataset.ltidDetails.length > 0 ? dataset.ltidDetails : [];
          /* Natural Person Details */
            /* Retrieve Foreign TID Country & Replacing Foreign TID Country */
              if (dataset.naturalPersonDetails.length > 0) {
                for(let i=0; i<dataset.naturalPersonDetails.length; i++) {
                  let NPColumns = Object.keys(dataset.naturalPersonDetails[i]);
                  for(let j=0; j<NPColumns.length; j++) {
                    if(_.includes(['foreignTIDCountryCd', 'replacingForeignTIDCountryCd'], NPColumns[j])) {
                      let countryCode = _.find(this.UserService.countryList, {value:dataset.naturalPersonDetails[i][NPColumns[j]]});
                      dataset.naturalPersonDetails[i][NPColumns[j]] = (countryCode ? countryCode.label : dataset.naturalPersonDetails[i][NPColumns[j]]);
                    }
                  }
                }
                dataset.naturalPersonDetails = dataset.naturalPersonDetails;
              }
            /* End of Retrieve Foreign TID Country & Replacing Foreign TID Country */
          this.NaturalPersonDataDetails = dataset.naturalPersonDetails.length > 0 ? dataset.naturalPersonDetails : [];
          this.NaturalPersons = [{id: 0, name: 'Add Natural Person'}];
          this.NaturalPersonAddressDetails = [];
          if(dataset.naturalPersonDetails.length > 0) {
            for(let i=0;i<dataset.naturalPersonDetails.length;i++) {
              this.NaturalPersons.push({
                id: (i+1),
                name: dataset.naturalPersonDetails[i]['firstName'] + ' ' + dataset.naturalPersonDetails[i]['lastName']
              });
              /* Natural Person Address Details */
                let NaturalPersonAddressData = [];
                for(let j=1; j<=4; j++) {
                  /* Retrieve Country & Region Code */
                  let countryCode, regionCountryCode;
                  if(dataset.legalEntityDetails[i]) {
                    countryCode = _.find(this.UserService.countryList, {value:dataset.naturalPersonDetails[i]['addr'+j+'_countryCode']});
                    regionCountryCode = _.find(this.UserService.countryRegionList, {value:dataset.naturalPersonDetails[i]['addr'+j+'_regionCode']});
                  }
                  let addressData={
                    'addr_addrLine1': dataset.naturalPersonDetails[i]['addr'+j+'_addrLine1'],
                    'addr_addrLine2': dataset.naturalPersonDetails[i]['addr'+j+'_addrLine2'],
                    'addr_addrLine3': dataset.naturalPersonDetails[i]['addr'+j+'_addrLine3'],
                    'addr_addrLine4': dataset.naturalPersonDetails[i]['addr'+j+'_addrLine4'],
                    'addr_city': dataset.naturalPersonDetails[i]['addr'+j+'_city'],
                    'addr_regionCode': (regionCountryCode ? regionCountryCode.label : dataset.naturalPersonDetails[i]['addr'+j+'_regionCode']),
                    'addr_countryCode': (countryCode ? countryCode.label : dataset.naturalPersonDetails[i]['addr'+j+'_countryCode']),
                    'addr_postalCode': dataset.naturalPersonDetails[i]['addr'+j+'_postalCode']
                  }
                  if(Object.values(addressData).some(value=>value && value.trim() !=='')){
                    NaturalPersonAddressData.push(addressData);
                  }
                }
                this.NaturalPersonAddressDetails.push(NaturalPersonAddressData);
              /* End of Natural Person Address Details */
            }
          }
          /* Legal Entity Details */
            /* Retrieve Foreign TID Country & Replacing Foreign TID Country */
              if (dataset.legalEntityDetails.length > 0) {
                for(let i=0; i<dataset.legalEntityDetails.length; i++) {
                  let LEColumns = Object.keys(dataset.legalEntityDetails[i]);
                  for(let j=0; j<LEColumns.length; j++) {
                    if(_.includes(['foreignTIDCountryCd', 'replacingForeignTIDCountryCd'], LEColumns[j])) {
                      let countryCode = _.find(this.UserService.countryList, {value:dataset.legalEntityDetails[i][LEColumns[j]]});
                      dataset.legalEntityDetails[i][LEColumns[j]] = (countryCode ? countryCode.label : dataset.legalEntityDetails[i][LEColumns[j]]);
                    }
                  }
                }
                dataset.naturalPersonDetails = dataset.naturalPersonDetails;
              }
            /* End of Retrieve Foreign TID Country & Replacing Foreign TID Country */
          this.LegalEntityDataDetails = dataset.legalEntityDetails.length > 0 ? dataset.legalEntityDetails : [];
          this.LegalEntities = [{id: 0, name: 'Add Legal Entity'}];
          this.LegalEntityAddressDetails = [];
          if(dataset.legalEntityDetails.length > 0) {
            for(let i=0;i<dataset.legalEntityDetails.length;i++) {
              this.LegalEntities.push({
                id: (i+1),
                name: dataset.legalEntityDetails[i]['legalName']
              });
              /* Legal Entity Address Details */
                let LegalEntityAddressData = [];
                for(let j=1; j<=4; j++) {
                  /* Retrieve Country & Region Code */
                  let countryCode, regionCountryCode;
                  if(dataset.legalEntityDetails[i]) {
                    countryCode = _.find(this.UserService.countryList, {value:dataset.legalEntityDetails[i]['addr'+j+'_countryCode']});
                    regionCountryCode = _.find(this.UserService.countryRegionList, {value:dataset.legalEntityDetails[i]['addr'+j+'_regionCode']});
                  }
                  let addressData={
                    'addr_addrLine1': dataset.legalEntityDetails[i]['addr'+j+'_addrLine1'],
                    'addr_addrLine2': dataset.legalEntityDetails[i]['addr'+j+'_addrLine2'],
                    'addr_addrLine3': dataset.legalEntityDetails[i]['addr'+j+'_addrLine3'],
                    'addr_addrLine4': dataset.legalEntityDetails[i]['addr'+j+'_addrLine4'],
                    'addr_city': dataset.legalEntityDetails[i]['addr'+j+'_city'],
                    'addr_regionCode': (regionCountryCode ? regionCountryCode.label : dataset.legalEntityDetails[i]['addr'+j+'_regionCode']),
                    'addr_countryCode': (countryCode ? countryCode.label : dataset.legalEntityDetails[i]['addr'+j+'_countryCode']),
                    'addr_postalCode': dataset.legalEntityDetails[i]['addr'+j+'_postalCode']
                  }
                  if(Object.values(addressData).some(value=>value && value.trim() !=='')){
                    LegalEntityAddressData.push(addressData);
                  }
                }
                this.LegalEntityAddressDetails.push(LegalEntityAddressData);
              /* End of Legal Entity Address Details */
            }
          }
          /* Mask Birth Date Field */
          if(this.yearField.length > 0) {
            this.maskYear();
          }
          this.selectedTabIndex = this.NaturalPersons.length;
          this.getSearchCustomerType(); // Receive Customer Type for Customer Search on the basis of Opted Tab Index
        }, error: (err: HttpErrorResponse) => {
            this.isViewLoadingResults = false;
      }});
    /* End of FDID View Detail */
  }

  isEmptyObject(ObjectParams: any) {
    if(Object.keys(ObjectParams).length > 0) {
      for (let key in ObjectParams) {
        if (key!=='errorFields' && (ObjectParams[key]!==null && ObjectParams[key]!=="")) {
          return false;
        }
      }
    }
    return true;
  }

  formFieldValidation() {
    /* FDID Validation */
    let screenDataFields = this.screenDataDetails;
    screenDataFields = screenDataFields.filter((screenDataField: { ui_Field_Name: any; }) => (!_.includes(this.addScreenNegotiatedFields, screenDataField.ui_Field_Name) && !_.includes(this.ExceptionalFDIDScreenFields, screenDataField.ui_Field_Name)));
    // Check the mandatory requirement for Dependent fields
    if(this.actionType === "Edit") {
      this.caisServiceService.checkDependentFieldRequirement(this.FDIDScreenDataDetails, screenDataFields, [{baseField: 'FDID End Date', dependentField: 'FDID End Reason', associatedFields: true}]);
    }
    this.validateFields(this.FDIDScreenDataDetails, screenDataFields); // Validating FDID Data

    /* LTID Validation */
    if(this.LTIDDataSet.length > 0) {
      for(let i=0;i<this.LTIDDataSet.length;i++) {
        if(!this.isEmptyObject(this.LTIDDataSet[i])) {
          this.validateFields(this.LTIDDataSet[i], this.LTIDScreenDataDetails); // Validating FDID Address Fields
        } else {
          delete this.LTIDDataSet[i].errorFields;
        }
      }
    }
    let LTIDDataSetErrorArray = this.LTIDDataSet.filter(LTIDDataSetObj => LTIDDataSetObj['errorFields'] && Object.keys(LTIDDataSetObj['errorFields']).length > 0);

    /* FDID Address Validation */
    if(this.FDIDAddressDetails.length > 0) {
      let addressFields = this.AddressDetails;
      for(let i=0;i<this.FDIDAddressDetails.length;i++) {
        if(i==0 || !this.isEmptyObject(this.FDIDAddressDetails[i])) {
          /* Previous Empty Address Fields Validation */
            this.previousEmptyAddressFieldValidation(i, this.FDIDAddressDetails, addressFields);
          /* End of Previous Empty Address Fields Validation */
          this.validateFields(this.FDIDAddressDetails[i], addressFields); // Validating FDID Address Fields
        } else {
          delete this.FDIDAddressDetails[i].errorFields;
        }
      }
    }
    let FDIDAddressErrorArray = this.FDIDAddressDetails.filter((FDIDAddObj: { [x: string]: {}; }) => FDIDAddObj['errorFields'] && Object.keys(FDIDAddObj['errorFields']).length > 0);

    /* Natural Person Tabs Validation */
      let allValidNaturalPersons = true;
      if(this.NaturalPersonDataDetails.length > 0) {
        for(let i=0; i<this.NaturalPersonDataDetails.length; i++) {
          allValidNaturalPersons = this.validateNaturalPerson(i);
          /* Validation for Initial Natural Person Tab */
            if(i===0) {
              if(this.isEmptyObject(this.NaturalPersonDataDetails[i])) {
                delete this.NaturalPersonDataDetails[i].errorFields;
                allValidNaturalPersons = true;
              }
            }
          /* End of Validation for Initial Natural Person Tab */
          if(allValidNaturalPersons && this.NaturalPersonDataDetails[i].errorFields && Object.keys(this.NaturalPersonDataDetails[i].errorFields).length === 0) {
            delete this.NaturalPersonDataDetails[i].errorFields;
          }
          /* Stop Page submission while found Field error */
          if(!allValidNaturalPersons) {
            break;
          }
        }
      }
    /* End of Natural Person Tabs Validation */
    /* Legal Entity Tabs Validation */
      let allValidLegalEntities = true;
      if(this.LegalEntityDataDetails.length > 0) {
        for(let i=0; i<this.LegalEntityDataDetails.length; i++) {
          allValidLegalEntities = this.validateLegalEntity(i);
          /* Validation for Initial Legal Entity Tab */
            if(i===0) {
              if(this.isEmptyObject(this.LegalEntityDataDetails[i])) {
                delete this.LegalEntityDataDetails[i].errorFields;
                allValidLegalEntities = true;
              }
            }
          /* End of Validation for Initial Legal Entity Tab */
          if(allValidLegalEntities && this.LegalEntityDataDetails[i].errorFields && Object.keys(this.LegalEntityDataDetails[i].errorFields).length === 0) {
            delete this.LegalEntityDataDetails[i].errorFields;
          }
          /* Stop Page submission while found Field error */
          if(!allValidLegalEntities) {
            break;
          }
        }
      }
    /* End of Legal Entity Tabs Validation */

    if(this.FDIDScreenDataDetails["fdidEndDate"]!=null && this.FDIDScreenDataDetails["fdidEndReason"]!=null){
      allValidNaturalPersons = true;
      allValidLegalEntities = true;
    }
    
    /* Final Validation Result */
    if(Object.keys(this.FDIDScreenDataDetails.errorFields).length > 0 || LTIDDataSetErrorArray.length > 0 || FDIDAddressErrorArray.length > 0 || !allValidNaturalPersons || !allValidLegalEntities) {
      return false;
    }
    return true;
  }
  
  validateAccountNumber() {
    if(this.actionType === "Add") {
      if (this.FDIDScreenDataDetails["errorFields"] && this.FDIDScreenDataDetails["errorFields"]['accountNumber']) {
        delete this.FDIDScreenDataDetails["errorFields"]['accountNumber'];
      }
      if (this.FDIDScreenDataDetails["errorFields"] && this.FDIDScreenDataDetails["errorFields"]['receivedFDID']) {
        delete this.FDIDScreenDataDetails["errorFields"]['receivedFDID'];
      }
      if(this.FDIDScreenDataDetails["accountNumber"]!=null 
      && this.FDIDScreenDataDetails["receivedFDID"]!=null
      && this.FDIDScreenDataDetails["accountNumber"].trim().length>0
      && this.FDIDScreenDataDetails["receivedFDID"].trim().length>0
      && this.FDIDScreenDataDetails["accountNumber"] !== this.FDIDScreenDataDetails["receivedFDID"]){
        this.FDIDScreenDataDetails["errorFields"]['accountNumber'] = "If AccountNumber and ReceivedFDID are entered then both values must be the same.";
        this.FDIDScreenDataDetails["errorFields"]['receivedFDID'] = "If ReceivedFDID and AccountNumber are entered then both values must be the same.";
      }
    }
  }

  validateRole(objectIndex: string | number,CustomerDetails: any) {
      if(CustomerDetails[objectIndex]["role"]!=null 
      && CustomerDetails[objectIndex]["role"].trim().length>0 && CustomerDetails[objectIndex]["role"] === 'AUTH3RD') {
        CustomerDetails[objectIndex]["errorFields"]['role'] = "‘AUTH3RD’ is not supported";
      }
  }

  addFDIDRecord() {
    this.isClickedOnce = true;
    this.isAddLoadingResults = true;

    /* Field Validations */
      if(!this.formFieldValidation()) {
        this.isClickedOnce = false;
        this.isAddLoadingResults = false;
        this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_WARN, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Please check required fields' });
        return false;
      }
    /* End of Field Validations */
    // Create an FDID object
      let FDIDObj :any = {};
      if(Object.keys(this.FDIDScreenDataDetails).length > 0) {
        _.entries(this.FDIDScreenDataDetails).forEach((keyValArr) => {
            FDIDObj[keyValArr[0]] = keyValArr[1];
        });
        FDIDObj["action"] = "ADD";
      }
      this.formatData(FDIDObj); // Formatting Data
      /* LTID Data Array */
      let LTIDArrayObject = [];
      if(this.LTIDDataSet.length > 0) {
        for(let i=0; i<this.LTIDDataSet.length; i++) {
          this.formatData(this.LTIDDataSet[i]); // Formatting Data
          if(!this.isEmptyObject(this.LTIDDataSet[i])) {
            LTIDArrayObject.push({...this.LTIDDataSet[i]});
          }
        }
      }
      // Create an FDID Address Array Object
      let FDIDAddressArray = [];
      if(this.FDIDAddressDetails.length > 0) {
        for(let j=1; j<=this.FDIDAddressDetails.length; j++) {
          if(!this.isEmptyObject(this.FDIDAddressDetails[j-1])) {
            FDIDAddressArray.push({
            "addrLine1": (this.FDIDAddressDetails[j-1]["addr_addrLine1"] ? this.FDIDAddressDetails[j-1]["addr_addrLine1"].trim() : null),
            "addrLine2": (this.FDIDAddressDetails[j-1]["addr_addrLine2"] ? this.FDIDAddressDetails[j-1]["addr_addrLine2"].trim() : null),
            "addrLine3": (this.FDIDAddressDetails[j-1]["addr_addrLine3"] ? this.FDIDAddressDetails[j-1]["addr_addrLine3"].trim() : null),
            "addrLine4": (this.FDIDAddressDetails[j-1]["addr_addrLine4"] ? this.FDIDAddressDetails[j-1]["addr_addrLine4"].trim() : null),
            "city": (this.FDIDAddressDetails[j-1]["addr_city"] ? this.FDIDAddressDetails[j-1]["addr_city"].trim() : null),
            "regionCode": (this.FDIDAddressDetails[j-1]["addr_regionCode"] ? this.FDIDAddressDetails[j-1]["addr_regionCode"] : null),
            "countryCode": (this.FDIDAddressDetails[j-1]["addr_countryCode"] ? this.FDIDAddressDetails[j-1]["addr_countryCode"] : null),
            "postalCode": (this.FDIDAddressDetails[j-1]["addr_postalCode"] ? this.FDIDAddressDetails[j-1]["addr_postalCode"].trim() : null)});
          }
        }
      }

      // Create a Natural Person Array Object
      let NaturalPersonArrayObject = [];
      if(this.NaturalPersonDataDetails.length > 0) {
        for(let i=0; i<this.NaturalPersonDataDetails.length; i++) {
          if(!this.isEmptyObject(this.NaturalPersonDataDetails[i])) {
            this.NaturalPersonDataDetails[i]['active'] = 'Y';
            let NaturalPersonObjectItem = _.cloneDeep(this.NaturalPersonDataDetails[i]);
            this.formatData(NaturalPersonObjectItem); // Formatting Data
            NaturalPersonArrayObject.push({...NaturalPersonObjectItem});
          }
        }
      }
      // Create a Legal Entity Array Object
      let LegalEntityArrayObject = [];
      if(this.LegalEntityDataDetails.length > 0) {
        for(let i=0; i<this.LegalEntityDataDetails.length; i++) {
          if(!this.isEmptyObject(this.LegalEntityDataDetails[i])) {
            this.LegalEntityDataDetails[i]['active'] = 'Y';
            let LegalEntityObjectItem = _.cloneDeep(this.LegalEntityDataDetails[i]);
            this.formatData(LegalEntityObjectItem); // Formatting Data
            LegalEntityArrayObject.push({...LegalEntityObjectItem});
          }
        }
      }

      let APIParams = {
        type: this.DefaultFilterArray[1].values,
        CATReporterIMID: this.UserService.getActiveMPID(),
        user: this.UserService.getUserName(),
        userName: this.UserService.getUserFirstName(),
        fdidDetails: FDIDObj,
        fdidAddrDetails: FDIDAddressArray,
        ltidDetails: LTIDArrayObject,
        legalEntityDetails: LegalEntityArrayObject,
        naturalPersonDetails: NaturalPersonArrayObject,
        createdUser: this.UserService.getUserFirstName()
      };
      this.sharedHttpClientService.post(
        this.urlService.setAPIURl(
          APIURL.CAIS_FDID_Add
        ), APIParams)
        .subscribe({
          next: (res:any) => {
          this.isClickedOnce = false;
          this.isAddLoadingResults = false;

          let dataset: any = res;
          if(dataset.status === true) {
            this.getData();
            this.getAdditionalData(); // Reset All Data after Saving FDID Record
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: dataset.message });
          } else {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: dataset.message });
          }
        }, error: (err: HttpErrorResponse) => {
          this.isClickedOnce = false;
          this.isAddLoadingResults = false;
        }});

        return true;
  }

  editFDIDRecord() {
    this.isClickedOnce = true;
    this.isEditLoadingResults = true;
    /* Field Validations */
      if(!this.formFieldValidation()) {
        this.isClickedOnce = false;
        this.isEditLoadingResults = false;
        this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_WARN, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Please check required fields' });
        return false;
      }
    /* End of Field Validations */
    // Create an FDID object
    let FDIDObj:any = {};
    if(Object.keys(this.FDIDScreenDataDetails).length > 0) {
      _.entries(this.FDIDScreenDataDetails).forEach((keyValArr) => {
          FDIDObj[keyValArr[0]] = keyValArr[1];
      });
      FDIDObj["action"] = "UPDATE";
    }
    this.formatData(FDIDObj); // Formatting Data
    /* LTID Data Array */
    let LTIDArrayObject = [];
    if(this.LTIDDataSet.length > 0) {
      for(let i=0; i<this.LTIDDataSet.length; i++) {
        this.formatData(this.LTIDDataSet[i]); // Formatting Data
        if(!this.isEmptyObject(this.LTIDDataSet[i])) {
          LTIDArrayObject.push({...this.LTIDDataSet[i]});
        }
      }
    }
    // Create an FDID Address Array Object
    let FDIDAddressArray = [];
    if(this.FDIDAddressDetails.length > 0) {
      for(let j=1; j<=this.FDIDAddressDetails.length; j++) {
        if(!this.isEmptyObject(this.FDIDAddressDetails[j-1])) {
          FDIDAddressArray.push({
          "addrLine1": (this.FDIDAddressDetails[j-1]["addr_addrLine1"] ? this.FDIDAddressDetails[j-1]["addr_addrLine1"].trim() : null),
          "addrLine2": (this.FDIDAddressDetails[j-1]["addr_addrLine2"] ? this.FDIDAddressDetails[j-1]["addr_addrLine2"].trim() : null),
          "addrLine3": (this.FDIDAddressDetails[j-1]["addr_addrLine3"] ? this.FDIDAddressDetails[j-1]["addr_addrLine3"].trim() : null),
          "addrLine4": (this.FDIDAddressDetails[j-1]["addr_addrLine4"] ? this.FDIDAddressDetails[j-1]["addr_addrLine4"].trim() : null),
          "city": (this.FDIDAddressDetails[j-1]["addr_city"] ? this.FDIDAddressDetails[j-1]["addr_city"].trim() : null),
          "regionCode": (this.FDIDAddressDetails[j-1]["addr_regionCode"] ? this.FDIDAddressDetails[j-1]["addr_regionCode"] : null),
          "countryCode": (this.FDIDAddressDetails[j-1]["addr_countryCode"] ? this.FDIDAddressDetails[j-1]["addr_countryCode"] : null),
          "postalCode": (this.FDIDAddressDetails[j-1]["addr_postalCode"] ? this.FDIDAddressDetails[j-1]["addr_postalCode"].trim() : null)});
        }
      }
    }
    // Create an Natural Person Array Object
    let NaturalPersonArrayObject = [];
    if(this.NaturalPersonDataDetails.length > 0) {
      for(let i=0; i<this.NaturalPersonDataDetails.length; i++) {
        /* Replacing Original Customer TID field values with Newer Customer TID field values */
        if(this.NaturalPersonDataDetails[i]['tidUpdate'] && this.NaturalPersonDataDetails[i]['tidUpdate']===this.caisServiceService.TIDUpdateStatuses[0] && this.NaturalPersonDataDetails[(i+1)]['tidUpdate'] && this.NaturalPersonDataDetails[(i+1)]['tidUpdate']===this.caisServiceService.TIDUpdateStatuses[1]) {
          this.caisServiceService.replaceTIDUpdateFieldValues(this.NaturalPersonDataDetails[i], this.NaturalPersonDataDetails[i+1]);
        } // End of Logic for replacing Original Customer TID field values with Newer Customer TID field values
        if(!this.isEmptyObject(this.NaturalPersonDataDetails[i])) {
          this.NaturalPersonDataDetails[i]['active'] = 'Y';
          let NaturalPersonObjectItem = _.cloneDeep(this.NaturalPersonDataDetails[i]);
          this.formatData(NaturalPersonObjectItem); // Formatting Data
          NaturalPersonArrayObject.push({...NaturalPersonObjectItem});
        }
      }
    }
    // Create an Legal Entity Array Object
    let LegalEntityArrayObject = [];
    if(this.LegalEntityDataDetails.length > 0) {
      for(let i=0; i<this.LegalEntityDataDetails.length; i++) {
        /* Replacing Original Customer TID field values with Newer Customer TID field values */
        if(this.LegalEntityDataDetails[i]['tidUpdate'] && this.LegalEntityDataDetails[i]['tidUpdate']===this.caisServiceService.TIDUpdateStatuses[0] && this.LegalEntityDataDetails[(i+1)]['tidUpdate'] && this.LegalEntityDataDetails[(i+1)]['tidUpdate']===this.caisServiceService.TIDUpdateStatuses[1]) {
          this.caisServiceService.replaceTIDUpdateFieldValues(this.LegalEntityDataDetails[i], this.LegalEntityDataDetails[i+1]);
        } // End of Logic for replacing Original Customer TID field values with Newer Customer TID field values
        if(!this.isEmptyObject(this.LegalEntityDataDetails[i])) {
          this.LegalEntityDataDetails[i]['active'] = 'Y';
          let LegalEntityObjectItem = _.cloneDeep(this.LegalEntityDataDetails[i]);
          this.formatData(LegalEntityObjectItem); // Formatting Data
          LegalEntityArrayObject.push({...LegalEntityObjectItem});
        }
      }
    }

    // Create an Array of IncustomerIds of Removed Customers
    let removedCustomerAPIParam = this.removedCustomers.map(rcObj => rcObj.inCustomerRecordID);
    if(this.isClickOnFDIDCorrection){
        FDIDObj['oldAccountNumber']=this.rowDataforDialog['accountNumber'];
        FDIDObj['oldReceivedFDID']=this.rowDataforDialog['receivedFDID'];
      }

    let APIParams = {
      type: this.DefaultFilterArray[1].values,
      CATReporterIMID: this.UserService.getActiveMPID(),
      user: this.UserService.getUserName(),
      userName: this.UserService.getUserFirstName(),
      fdidDetails: FDIDObj,
      fdidAddrDetails: FDIDAddressArray,
      ltidDetails: LTIDArrayObject,
      legalEntityDetails: LegalEntityArrayObject,
      naturalPersonDetails: NaturalPersonArrayObject,
      removedCustomers: removedCustomerAPIParam,
      updatedUser: this.UserService.getUserFirstName(),
      isFDIDCorrection: this.isClickOnFDIDCorrection,
    };
    this.sharedHttpClientService.post(
      this.urlService.setAPIURl(
        APIURL.CAIS_FDID_Edit
      ), APIParams)
      .subscribe({
        next: (res:any) => {
        this.isClickedOnce = false;
        this.isEditLoadingResults = false;

        let dataset: any = res;
        if(dataset.status === true) {
          this.Edit = false;
          this.getData();
          this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: dataset.message });
        } else {
          this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: dataset.message });
        }
      }, error: (err: HttpErrorResponse) => {
        this.isClickedOnce = false;
        this.isEditLoadingResults = false;
      }});

      return true;
  }

  formatData(DataObject: any) {
    for (const key in DataObject) {
      const match = /(GMT.*\))/.exec(DataObject[key]);
      if(typeof DataObject[key] === 'object' && match && match.length > 0) {
        DataObject[key] = DataObject[key] ? format(new Date(DataObject[key]), 'yyyy-MM-dd') : '';
      } else if(typeof DataObject[key] === 'object' && DataObject[key] && DataObject[key].length > 0) {
        DataObject[key] = DataObject[key].join('@');
      } else if(typeof DataObject[key] === 'string') {
        DataObject[key] = DataObject[key] ? DataObject[key].trim() : null;
      } else {
        DataObject[key] = DataObject[key] ? DataObject[key] : null;
      }
    }
  }

  validateFields(dataObj:any, screenFields: string | any[]) {
    if(screenFields.length > 0) {
      if(!dataObj["errorFields"]) {
        dataObj["errorFields"] = [];
      }
      this.validateAccountNumber();
      this.validateDVPCustodianID();
      for(let i=0; i<screenFields.length; i++) {
        /* Required Field Validation */
        if(screenFields[i]["isrequired"]===true && screenFields[i]["isDisable"]!==true && (!dataObj[screenFields[i]['field_Name']] || dataObj[screenFields[i]['field_Name']]==="" || dataObj[screenFields[i]['field_Name']]===null || (screenFields[i]['datatype']==='Array' && dataObj[screenFields[i]['field_Name']].length===0))) {
          dataObj["errorFields"][screenFields[i]['field_Name']] = "Please enter required field";
          continue;
        } else if(screenFields[i]["isrequired"]===true && dataObj[screenFields[i]['field_Name']]) {
          delete dataObj["errorFields"][screenFields[i]['field_Name']];
        }
        /* Alternative Field Validation */
        this.checkAlterNativeField(dataObj, screenFields[i]);
        /* Field format Validation */
        if(this.caisServiceService.checkRegexpressionValidity(dataObj, screenFields[i])) {
          let validFieldFormat = false;
          for(let j=0; j<screenFields[i]["regexpressions"].length; j++) {
            if(new RegExp(screenFields[i]["regexpressions"][j]).test(dataObj[screenFields[i]['field_Name']])===true) {
              validFieldFormat = true;
              delete dataObj["errorFields"][screenFields[i]['field_Name']];
            }
          }
          if(validFieldFormat === false) {
            dataObj["errorFields"][screenFields[i]['field_Name']] = "Please enter valid format";
            continue;
          }
        }

      }
    }
  }

  validateDVPCustodianID() {
    if (this.FDIDScreenDataDetails['accountType']?.includes('DVP/RVP')) {
      if (!this.FDIDScreenDataDetails['DVPCustodianID'] || this.FDIDScreenDataDetails['DVPCustodianID'] === '') {
        this.FDIDScreenDataDetails["errorFields"]['DVPCustodianID'] = "Please enter required field";
      }
      else {
        delete this.FDIDScreenDataDetails["errorFields"]['DVPCustodianID'];
      }
    }
  }

  GridChangeLimitEvent(event: any) {
    this.Limit = event;
    this.getData();
  }

  defaultFilter() {
    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Report Date', 'columnname': 'reportDate', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Record Type', 'columnname': 'staging', 'filterby': 'IS', 'values': 'STAGING', 'time': '', 'datatype': 'skip', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'singleSelect', 'dropdownvalue': [
        {'label': 'Not Submitted', 'value': 'STAGING', 'description': 'Access from Staging DB'},
        {'label': 'Submitted', 'value': 'MASTER', 'description': 'Access from Master DB'}],
        'module': 'CAIS'
      },
      { 'isdefault': 'true', 'label': 'Finra Status', 'columnname': 'lastFinraStatus', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'singleSelect', 'dropdownvalue': [
        {'label': 'SUBMITTED', 'value': 'SUBMITTED', 'description': 'Records is Submitted'},
        {'label': 'ACCEPTED', 'value': 'ACCEPTED', 'description': 'Records is Accepted'},
        {'label': 'REJECTED', 'value': 'REJECTED', 'description': 'Records is Rejected'},
        {'label': 'INCONSISTANCY', 'value': 'INCONSISTANCY', 'description': 'Records has Inconsistancy'}]
      },
      { 'isdefault': 'true', 'label': 'Active', 'columnname': 'active', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true','dropdown': 'YES', 'dropdowntype': 'singleSelect', 'dropdownvalue': [
        {'label': 'Y', 'value': 'Y', 'description': 'True'},
        {'label': 'N', 'value': 'N', 'description': 'False'}]
      },
      { 'isdefault': 'true', 'label': 'Customer Record ID', 'columnname': 'customerRecordID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      { 'isdefault': 'true', 'label': 'In Customer Record ID', 'columnname': 'inCustomerRecordID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      { 'isdefault': 'true', 'label': 'Account Number', 'columnname': 'accountNumber', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Received FDID', 'columnname': 'receivedFDID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Account Name', 'columnname': 'accountName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'FDID Date', 'columnname': 'fdidDate', 'filterby': '=', 'values': '', 'time': '', 'datatype': 'Date', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'FDID End Date', 'columnname': 'fdidEndDate', 'filterby': '=', 'values': '', 'time': '', 'datatype': 'Date', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Account Type', 'columnname': 'accountType', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Customer Type', 'columnname': 'customerType', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Role Start Date', 'columnname': 'roleStartDate', 'filterby': '=', 'values': '', 'time': '', 'datatype': 'Date', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
    ];
    this.getData();
  }

  changePage(event: { first: any; rows: number; }) {
    this.startLimit = event.first;
    this.endLimit = this.startLimit + this.rowcount;
    this.rowcount = event.rows;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.priviousStartLimit = this.startLimit;
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;

    this.getData();
  }

  getData() {
    this.dataService.roeSelectedRecords = [];
    this.dataset = [];
    this.isLoadingResults = true;
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.previousLimit = this.Limit;
    this.tbldatamsg = 'L o a d i n g . . . . .';

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    if(filterData[0].values.length === 2) {
      filterData[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
      filterData[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    }

    /* set post dataset */
    this.sharedHttpClientService.post(
      this.urlService.setAPIURl(
        APIURL.CAIS_FDID_List
      ), {
        data: filterData,
        type: this.DefaultFilterArray[1].values,
        CATReporterIMID: this.UserService.getActiveMPID(),
        user: this.UserService.getUserName(),
        userName: this.UserService.getUserFirstName(),
        startLimit: this.Limit.Start.toString(),
        endLimit: this.Limit.End.toString()
      }
    ).subscribe({
      next: (element:any) => {
        let dataset: any = element;
        this.dataset = dataset.Data;
        /* Displaying Country & Region Name */
        if(this.dataset && this.dataset.length > 0) {
          this.dataset.forEach(col => {
            let countryCode = _.find(this.UserService.countryList, {value:col['countryCode']});
            col['countryCode'] = (countryCode ? countryCode.label : col['countryCode']);
            let regionCountryCode = _.find(this.UserService.countryRegionList, {value:col['regionCode']});
            col['regionCode'] = (regionCountryCode ? regionCountryCode.label : col['regionCode']);
          });
        }

        this.defaultData = this.dataset;
        this.dataset = _.orderBy(_.sortBy(this.dataset, this.sortData.field), [this.sortData.field], [this.sortData.order]);
        this.totalRecords = dataset.totalCount;
        this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);

        if (this.dataset.length == 0) {
          this.tbldatamsg = "No data found";
        }
        this.isLoadingResults = false;
      }, error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
    }});
  }

  exportToCSV(event: any) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    // to let user know the button is clicked and download process is started
    this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_INFO, summary: this.constantService.MESSAGE_SUMMARY_INFO, detail: 'Please wait.. Preparing export file to download..' });

    if (event.isExportMaxRows) {
      this.Limit = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
      this.Limit = this.previousLimit;
    }

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    if(filterData[0].values.length === 2) {
      filterData[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
      filterData[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    }

    const exportCSVPayload = {
      "data": JSON.parse(JSON.stringify(filterData)),
      "type": this.DefaultFilterArray[1].values,
      "CATReporterIMID": this.UserService.getActiveMPID(),
      "user": this.UserService.getUserName(),
      "userName": this.UserService.getUserFirstName(),
      "startLimit": this.Limit.Start + "",
      "endLimit": this.Limit.End + ""
    };

    this.sharedHttpClientService.post(
      this.urlService.setAPIURl(APIURL.CAIS_FDID_List),
      exportCSVPayload
    ).pipe(map((response: Response) => {
      return response;
    })).subscribe({
      next: (element:any) => {
      this.isLoadingResults = false;

      let dataset: any = element;
      let data = dataset.Data;

      /* Displaying Country & Region Name */
      if(data.length > 0) {
        data.forEach((col: { [x: string]: any; }) => {
          let countryCode = _.find(this.UserService.countryList, {value:col['countryCode']});
          col['countryCode'] = (countryCode ? countryCode.label : col['countryCode']);
          let regionCountryCode = _.find(this.UserService.countryRegionList, {value:col['regionCode']});
          col['regionCode'] = (regionCountryCode ? regionCountryCode.label : col['regionCode']);
        });
      }

      if (data.length > 0) {
        const options: any = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title: 'RSMS_CAIS_FDID_' + this.UserService.getyyyyMMddDateFormate(new Date()),
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
          filename: this.UserService.getActiveMPID() + '_RSMS_CAIS_FDID_' + this.UserService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
        };
        const csvData = this.constantService.getExportData(data, event.gridColumn);
        const csv = generateCsv(options)(csvData);
        const blob = asBlob(options)(csv);
        saveAs(blob,options.filename);

        this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: 'File Download Successfully' });
        this.UserService.logUserActivity('Export CSV', null, {
          'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      } else {
        this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'No data found' });
        this.UserService.logUserActivity('Export CSV', null, {
          'Text1': 'No data found',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
      this.emitterService.exportToCSVData.emit(true);
    }, error: (err: HttpErrorResponse) => {
      this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Error while Exporting' });
      this.UserService.logUserActivity('Export CSV', null, {
        'Text1': 'Error while Exporting',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    }});
  }

  sort(event: any) {
    if (this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    }
    if (this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      this.dataset = this.sortPipe.transform(this.dataset, this.sortData.order, this.sortData.field);
    } else {
      this.resetSort()
    }

  }

  resetSort() {
    if(this.dt.multiSortMeta != undefined && this.dt.multiSortMeta?.length > 0) {
    this.dt.multiSortMeta[0].field = '';
    this.dt.multiSortMeta[0].order = 0;
    }

    this.dataset = this.defaultData;
  }

  /* sendToSubmitState(rowData = {}) {
    if (this.dataService.roeSelectedRecords.length <= 1) {
      this.dataService.roeSelectedRecords = [];
      this.dataService.roeSelectedRecords[0] = (rowData);
    }
    this.confirmationService.confirm({
      message: 'You will be able to shift selected Record(s) to Submitted state with this action. Do you want to Proceed?',
      key: 'informationDialoge',
      accept: () => {
        this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_INFO, summary: this.constantService.MESSAGE_SUMMARY_INFO, detail: 'Records are moving...' });
        let payLoad = {
          type: this.DefaultFilterArray[1].values,
          mpid: this.UserService.getActiveMPID(),
          user: this.UserService.getUserName(),
          userName: this.UserService.getUserFirstName(),
          movedData: this.dataService.roeSelectedRecords,
          reportDate: this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(rowData['reportDate'])))
        };
        this.sharedHttpClientService.post(
          this.urlService.setAPIURl(
            APIURL.Move_Staging_To_Master
          ), payLoad)
        .subscribe((res) => {
          let resultSet: any = res.json();
          if(resultSet) {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: 'Moved Records from Staging to Master' });
          } else {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Failed Moving Records from Staging to Master' });
          }
        });
      }
    });
  } */

  addNewTab(tabType: String) {
    this.isClickOnTIDCorrection = false;
    this.isClickOnFDIDCorrection = false;
    if(tabType==='Natural Person') {
      let initialNaturalPersonObj = this.NaturalPersons.find(npObj => npObj.id === 0);
      this.selectedTabIndex = initialNaturalPersonObj.tabIndex;
      this.getSearchCustomerType(); // Receive Customer Type for Customer Search on the basis of Opted Tab Index
    } else if(tabType==='Legal Entity') {
      let initialLegalEntityObj = this.LegalEntities.find(leObj => leObj.id === 0);
      this.selectedTabIndex = initialLegalEntityObj.tabIndex;
      this.getSearchCustomerType(); // Receive Customer Type for Customer Search on the basis of Opted Tab Index
    }
  }

  handleChange(e: any) {
    this.isClickOnTIDCorrection = false;
    this.isClickOnFDIDCorrection = false;
    this.selectedTabIndex = e;
    this.getSearchCustomerType(); // Receive Customer Type for Customer Search on the basis of Opted Tab Index 
    this.maskYear();
  }

  /* Receive Customer Type on the basis of User Opted Customer Tab */
  getSearchCustomerType() {
    /* Check whether Opted Customer is Natural-Person */
      let initialOptedNaturalPersonIndex = this.NaturalPersons.findIndex(npObj => npObj.tabIndex === this.selectedTabIndex);
      if(initialOptedNaturalPersonIndex > -1) {
        this.selectedCustomerType = this.NaturalPersons[initialOptedNaturalPersonIndex].tabType;
      }

    /* Check whether Opted Customer is Legal-Entity */
      let initialOptedLegalEntityIndex = this.LegalEntities.findIndex(leObj => leObj.tabIndex === this.selectedTabIndex);
      if(initialOptedLegalEntityIndex > -1) {
        this.selectedCustomerType = this.LegalEntities[initialOptedLegalEntityIndex].tabType;
      }
  }

  resetNaturalPerson(objectIndex: string | number) {
    /* Empty Natural Person Data Details */
    if(this.NaturalPersonDataDetails[objectIndex]) {
      for (let property in this.NaturalPersonDataDetails[objectIndex]) {
        this.NaturalPersonDataDetails[objectIndex][property] = "";
      }
    }
    /* Empty Natural Person Address Data Details */
    if(this.NaturalPersonAddressDetails.length > 0) {
      let addressColumns = this.AddressGridColumns.map((column: {db_columnname: string}) => column.db_columnname);
      for(let j=1; j<=4; j++) {
        for(let k=0; k<addressColumns.length; k++) {
          if(this.NaturalPersonAddressDetails[objectIndex][j-1]) {
            this.NaturalPersonAddressDetails[objectIndex][j-1][addressColumns[k]] = "";
          }
        }
        if(this.NaturalPersonAddressDetails[objectIndex][j-1]) {
          this.NaturalPersonAddressDetails[objectIndex][j-1]["errorFields"] = "";
        }
      }
    }
  }

  saveNaturalPerson(objectIndex: number) {
    this.isAddLoadingResults = true;
    this.isEditLoadingResults = true;

    let isValidNaturalPerson = this.validateNaturalPerson(objectIndex);

    /* Stop Page submission while found Field error */
    if(!isValidNaturalPerson) {
      this.isAddLoadingResults = false;
      this.isEditLoadingResults = false;
      return false;
    } else {
      // Remove Error Code from Row
      if(Object.keys(this.NaturalPersonDataDetails[objectIndex].errorFields).length===0) {
        delete this.NaturalPersonDataDetails[objectIndex].errorFields;
      }
      this.NaturalPersonDataDetails[objectIndex]['active'] = 'Y';
      this.NaturalPersonDataDetails[objectIndex]['fileID'] = ((this.NaturalPersonDataDetails[objectIndex]['fileID'] && this.NaturalPersonDataDetails[objectIndex]['fileID']!==null) ? this.NaturalPersonDataDetails[objectIndex]['fileID'] : 0);
      let formDataObj = _.cloneDeep(this.NaturalPersonDataDetails[objectIndex]);
      this.formatData(formDataObj); // Formatting Data

      /* Add/Update Natural Person */
        this.sharedHttpClientService.post(
          this.urlService.setAPIURl(
            APIURL.addNaturalPersonData
          ), {
              type: this.DefaultFilterArray[1].values,
              CATReporterIMID: this.UserService.getActiveMPID(),
              user: this.UserService.getUserName(),
              userName: this.UserService.getUserFirstName(),
              reportDate: this.UserService.getyyyyMMddDateFormate(new Date()),
              formData: formDataObj,
              createdUser: this.UserService.getUserFirstName()
          })
          .subscribe({
            next: (res:any) => {
              let dataset: any = res;
              this.isAddLoadingResults = false;
              this.isEditLoadingResults = false;
              this.newtabIndex = this.getTabIndex();
              /* Add New Inserted Natural Person Tab */
                if(objectIndex === 0) {
                  this.NaturalPersons.push({
                    id: Object.keys(this.NaturalPersonDataDetails).length,
                    name: this.caisServiceService.getNaturalPersonTabName(this.NaturalPersonDataDetails[objectIndex]["firstName"], this.NaturalPersonDataDetails[objectIndex]["lastName"], this.NaturalPersons.length.toString()),
                    tabIndex: this.newtabIndex,
                    tabType: this.constantService.customerTypes[0]
                  });
                  this.NaturalPersonDataDetails.push({...this.NaturalPersonDataDetails[objectIndex]});
                  let NaturalPersonAddresses = structuredClone(this.NaturalPersonAddressDetails[objectIndex]);
                  this.formatData(NaturalPersonAddresses); // Formatting Data
                  this.NaturalPersonAddressDetails.push(NaturalPersonAddresses);
                  this.resetNaturalPerson(objectIndex);
                }
              /* End of Adding New Inserted Natural Person Tab */
              if(dataset.status === true) {
                this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: dataset.message });
              } else {
                this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: dataset.message });
              }
          }, error: (err: HttpErrorResponse) => {
              this.isAddLoadingResults = false;
              this.isEditLoadingResults = false;
          }
      });

      return true;
    }
  }

  resetLegalEntity(objectIndex: string | number) {
    /* Empty Legal Entity Data Details */
    if(this.LegalEntityDataDetails[objectIndex]) {
      for (let property in this.LegalEntityDataDetails[objectIndex]) {
        this.LegalEntityDataDetails[objectIndex][property] = "";
      }
    }
    /* Empty Legal Entity Address Data Details */
    if(this.LegalEntityAddressDetails.length > 0) {
      let addressColumns = this.AddressGridColumns.map((column: {db_columnname: string}) => column.db_columnname);
      for(let j=1; j<=4; j++) {
        for(let k=0; k<=addressColumns.length; k++) {
          if(this.LegalEntityAddressDetails[objectIndex][j-1]) {
            this.LegalEntityAddressDetails[objectIndex][j-1][addressColumns[k]] = "";
          }
        }
        if(this.LegalEntityAddressDetails[objectIndex][j-1]) {
          this.LegalEntityAddressDetails[objectIndex][j-1]["errorFields"] = "";
        }
      }
    }
  }

  saveLegalEntity(objectIndex: number) {
    this.isAddLoadingResults = true;
    this.isEditLoadingResults = true;

    let isValidLegalEntity = this.validateLegalEntity(objectIndex);

    /* Stop Page submission while found Field error */
    if(!isValidLegalEntity) {
      this.isAddLoadingResults = false;
      this.isEditLoadingResults = false;
      return false;
    } else {
      // Remove Error Code from Row
      if(Object.keys(this.LegalEntityDataDetails[objectIndex].errorFields).length===0) {
        delete this.LegalEntityDataDetails[objectIndex].errorFields;
      }
      this.LegalEntityDataDetails[objectIndex]['active'] = 'Y';
      this.LegalEntityDataDetails[objectIndex]['fileID'] = ((this.LegalEntityDataDetails[objectIndex]['fileID'] && this.LegalEntityDataDetails[objectIndex]['fileID']!==null) ? this.LegalEntityDataDetails[objectIndex]['fileID'] : 0);
      let formDataObj = _.cloneDeep(this.LegalEntityDataDetails[objectIndex]);
      this.formatData(formDataObj); // Formatting Data
      
      /* Add/Update Legal Entity */
        this.sharedHttpClientService.post(
          this.urlService.setAPIURl(
            APIURL.addLegalEntityData
          ), {
              type: this.DefaultFilterArray[1].values,
              CATReporterIMID: this.UserService.getActiveMPID(),
              user: this.UserService.getUserName(),
              userName: this.UserService.getUserFirstName(),
              reportDate: this.UserService.getyyyyMMddDateFormate(new Date()),
              formData: formDataObj,
              createdUser: this.UserService.getUserFirstName()
          })
          .subscribe({
            next: (res:any) => {
              let dataset: any = res;
              this.isAddLoadingResults = false;
              this.isEditLoadingResults = false;
              this.newtabIndex = this.getTabIndex();
              /* Add New Inserted Legal Entity Tab */
                if(objectIndex === 0) {
                  this.LegalEntities.push({
                    id: Object.keys(this.LegalEntityDataDetails).length,
                    name: this.caisServiceService.getLegalEntityTabName(this.LegalEntityDataDetails[objectIndex]['legalName'], this.LegalEntities.length.toString()),
                    tabIndex: this.newtabIndex,
                    tabType: this.constantService.customerTypes[1]
                  });
                  this.LegalEntityDataDetails.push({...this.LegalEntityDataDetails[objectIndex]});
                  let LegalEntityAddresses = structuredClone(this.LegalEntityAddressDetails[objectIndex]);
                  this.formatData(LegalEntityAddresses); // Formatting Data
                  this.LegalEntityAddressDetails.push(LegalEntityAddresses);
                  this.resetLegalEntity(objectIndex);
                }
              /* End of Adding New Inserted Legal Entity Tab */
              if(dataset.status === true) {
                this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: dataset.message });
              } else {
                this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: dataset.message });
              }
          }, error: (err: HttpErrorResponse) => {
              this.isAddLoadingResults = false;
              this.isEditLoadingResults = false;
          }
      });
      return true;
    }
  }

  removeNaturalPerson(objectIndex: number) {
    this.confirmationService.confirm({
      message: 'Are you sure to delete the Natural Person?',
      key: 'informationDialoge',
      acceptLabel: 'Ok',
      acceptIcon:'pi pi-check',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button information-reject-button",

      accept: () => {
        this.checkAndAddtoRemovedCustomerList('Natural-Person', objectIndex); // Check And Add Removed Natural-Person in Removed Customer List
        this.NaturalPersons.splice(objectIndex, 1);
        this.NaturalPersonDataDetails.splice(objectIndex, 1);
        this.NaturalPersonAddressDetails.splice(objectIndex, 1);
        $(() => {
          this.storeBirthYear.splice(objectIndex, 1);
        });
        this.removeTIDUpdatedTabIndexes('Natural-Person', objectIndex); // Remove TID Updated Tab Data
        this.updateFDIDInCustomerID(); // Update FDID In-CustomerID when Removing Associate Natural-Person
      }
    });
  }

  removeLegalEntity(objectIndex: number) {
    this.confirmationService.confirm({
      message: 'Are you sure to delete the Legal Entity?',
      key: 'informationDialoge',
      acceptLabel: 'Ok',
      acceptIcon:'pi pi-check',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button information-reject-button",

      accept: () => {
        this.checkAndAddtoRemovedCustomerList('Legal-Entity', objectIndex); // Check And Add Removed Legal-Entity in Removed Customer List
        this.LegalEntities.splice(objectIndex, 1);
        this.LegalEntityDataDetails.splice(objectIndex, 1);
        this.LegalEntityAddressDetails.splice(objectIndex, 1);
        this.removeTIDUpdatedTabIndexes('Legal-Entity', objectIndex); // Remove TID Updated Tab Data
        this.updateFDIDInCustomerID(); // Update FDID In-CustomerID when Removing Associate Legal-Entity
      }
    });
  }

  removeTIDUpdatedTabIndexes(tabName: string, objectIndex: number) {
    // Remove tidUpdate Property from Original Customer Object
    if(tabName==="Natural-Person" && this.NaturalPersonDataDetails[(objectIndex-1)]['tidUpdate'] && this.NaturalPersonDataDetails[(objectIndex-1)]['tidUpdate']===this.caisServiceService.TIDUpdateStatuses[0]) {
      delete this.NaturalPersonDataDetails[(objectIndex-1)]['tidUpdate'];
    } else if (tabName==="Legal-Entity" && this.LegalEntityDataDetails[(objectIndex-1)]['tidUpdate'] && this.LegalEntityDataDetails[(objectIndex-1)]['tidUpdate']===this.caisServiceService.TIDUpdateStatuses[0]) {
      delete this.LegalEntityDataDetails[(objectIndex-1)]['tidUpdate'];
    }

    // Remove relevant Customer Tab Indexes from TIDUpdatedTab Indexes Array
    let TIDUpdatedTabs = [this.selectedTabIndex, (this.selectedTabIndex-1)];
    for(let i=0; i < TIDUpdatedTabs.length; i++) {
      if(this.TIDUpdatedTabIndexes.includes(TIDUpdatedTabs[i])) {
        this.TIDUpdatedTabIndexes.splice(this.TIDUpdatedTabIndexes.indexOf(TIDUpdatedTabs[i]), 1);
      }
    }
    this.selectedTabIndex = (this.selectedTabIndex-1); // Reset and keep selected Tab to the Original Customer Tab
    this.getSearchCustomerType(); // Receive Customer Type for Customer Search on the basis of Opted Tab Index
  }

  // Update FDID In-CustomerID when Removing Associate Customer (Natural-Person/Legal-Entity)
  updateFDIDInCustomerID() {
    // Search FDID Associated NaturalPerson OR LegalEntity
    let FDIDAssociatedNaturalPerson = this.NaturalPersonDataDetails.filter((rowObj: { inCustomerRecordID: any; }) => this.FDIDScreenDataDetails.inCustomerRecordID === rowObj.inCustomerRecordID);
    let FDIDAssocitedLegalEntity = this.LegalEntityDataDetails.filter((rowObj: { inCustomerRecordID: any; }) => this.FDIDScreenDataDetails.inCustomerRecordID === rowObj.inCustomerRecordID);

    // When don't have FDID Associated NaturalPerson OR LegalEntity then Searching and assigning Supplement Associated NaturalPerson OR LegalEntity and attach to FDID
    if(FDIDAssociatedNaturalPerson.length === 0 && FDIDAssocitedLegalEntity.length === 0) {
      let SupplementAssociatedNaturalPerson = this.NaturalPersonDataDetails.find((itemObj: { inCustomerRecordID: { trim: () => { (): any; new(): any; length: number; }; }; }) => itemObj.inCustomerRecordID && itemObj.inCustomerRecordID.trim().length > 0);
      let SupplementAssociatedLegalEntity = this.LegalEntityDataDetails.find((itemObj: { inCustomerRecordID: { trim: () => { (): any; new(): any; length: number; }; }; }) => itemObj.inCustomerRecordID && itemObj.inCustomerRecordID.trim().length > 0);

      // Firstly Attach Supplement associated NaturalPerson to FDID | Secondly Attach Supplement associated Legal Entity to FDID | Last Attach null if don't have Supplement associated Natural Person OR Legal Entity
      if(SupplementAssociatedNaturalPerson && SupplementAssociatedNaturalPerson.inCustomerRecordID.trim().length > 0) {
        this.FDIDScreenDataDetails.inCustomerRecordID = SupplementAssociatedNaturalPerson.inCustomerRecordID;
        this.removedCustomers.push(SupplementAssociatedNaturalPerson); // Add Attached Natural-Person Customer in Removed CustomerList
      } else if(SupplementAssociatedLegalEntity && SupplementAssociatedLegalEntity.inCustomerRecordID.trim().length > 0) {
        this.FDIDScreenDataDetails.inCustomerRecordID = SupplementAssociatedLegalEntity.inCustomerRecordID;
        this.removedCustomers.push(SupplementAssociatedLegalEntity); // Add Attached Legal-Entity Customer in Removed CustomerList
      } else if(!SupplementAssociatedNaturalPerson && !SupplementAssociatedLegalEntity && this.FDIDScreenDataDetails.inCustomerRecordID && this.FDIDScreenDataDetails.inCustomerRecordID.trim().length > 0) {
        this.FDIDScreenDataDetails.inCustomerRecordID = null;
      }
    }
  }

  // Prepare Removed Customers (Natural-Person/Legal-Entity) Array
  checkAndAddtoRemovedCustomerList(tabName: string, objectIndex: string | number) {
    if(tabName==="Natural-Person") {
      let existRemovedCustomer = this.removedCustomers.filter((rowObj) => rowObj.inCustomerRecordID === this.NaturalPersonDataDetails[objectIndex].inCustomerRecordID);
      if(existRemovedCustomer.length===0) {
        this.removedCustomers.push(this.NaturalPersonDataDetails[objectIndex]);
      }
    } else if(tabName==="Legal-Entity") {
      let existRemovedCustomer = this.removedCustomers.filter((rowObj) => rowObj.inCustomerRecordID === this.LegalEntityDataDetails[objectIndex].inCustomerRecordID);
      if(existRemovedCustomer.length===0) {
        this.removedCustomers.push(this.LegalEntityDataDetails[objectIndex]);
      }
    }
  }

  validateNaturalPerson(objectIndex: number) {
    let naturalPersonScreenDataFields = this.NaturalPersonScreenDataDetails;
    naturalPersonScreenDataFields = naturalPersonScreenDataFields.filter((naturalPersonScreenDataField: { ui_Field_Name: any; }) => (!_.includes(this.addScreenNegotiatedFields, naturalPersonScreenDataField.ui_Field_Name)));

    // Check the mandatory requirement for Dependent fields
    this.caisServiceService.checkDependentFieldRequirement(this.NaturalPersonDataDetails[objectIndex], naturalPersonScreenDataFields, [{baseField: 'Role End Date', dependentField: 'Role End Reason', associatedFields: true}, {baseField: 'TID Type', baseFieldValues: this.caisServiceService.TIDTypes, dependentField: 'Foreign TID Type'}, {baseField: 'Foreign TID Type', baseFieldValues: this.caisServiceService.foreignTIDTypes, dependentField: 'Foreign TID Country'}, {baseField: 'Role', baseFieldValues: this.caisServiceService.customerDiscretionRoleTypes, dependentField: 'Has Discretion'}]);

    this.validateSingleObjectFormFields(objectIndex, this.NaturalPersonDataDetails, naturalPersonScreenDataFields);

    /* Check Role */
    this.validateRole(objectIndex,this.NaturalPersonDataDetails);

    /* Check for TID existence */
    this.caisServiceService.checkTIDExistence(this.NaturalPersonDataDetails[objectIndex], this.NaturalPersonDataDetails, this.LegalEntityDataDetails);

    /* Natural Person Address Fields */
      if(this.NaturalPersonAddressDetails.length > 0) {
        this.dataService.formAddressDetails(this.AddressGridColumns, this.NaturalPersonDataDetails[objectIndex], this.NaturalPersonAddressDetails[objectIndex]); // Assign Address Field Values
      }
      /* Natural Person Address Validation */
        if(this.NaturalPersonAddressDetails[objectIndex].length > 0) {
          let addressFields = this.AddressDetails;
          for(let i=0;i<this.NaturalPersonAddressDetails[objectIndex].length;i++) {
            if((i==0 && !this.isEmptyObject(this.NaturalPersonDataDetails[objectIndex])) || !this.isEmptyObject(this.NaturalPersonAddressDetails[objectIndex][i])) {
              /* Previous Empty Address Fields Validation */
                this.previousEmptyAddressFieldValidation(i, this.NaturalPersonAddressDetails[objectIndex], addressFields);
              /* End of Previous Empty Address Fields Validation */
              this.validateFields(this.NaturalPersonAddressDetails[objectIndex][i], addressFields); // Validating Natural Person Address Fields
            } else {
              delete this.NaturalPersonAddressDetails[objectIndex][i].errorFields;
            }
          }
        }
        
        let NaturalPersonAddressErrorArray = this.NaturalPersonAddressDetails[objectIndex].filter((NaturalPersonAddObj: { [x: string]: {}; }) => NaturalPersonAddObj['errorFields'] && Object.keys(NaturalPersonAddObj['errorFields']).length>0);
      /* End of Natural Person Address Validation */
    /* End of Natural Person Address Fields */
    /* Stop Page submission while found Field error */
    if((this.NaturalPersonDataDetails[objectIndex] && Object.keys(this.NaturalPersonDataDetails[objectIndex].errorFields).length > 0) || NaturalPersonAddressErrorArray.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  validateLegalEntity(objectIndex: number) {
    let legalEntityScreenDataFields = this.LegalEntityScreenDataDetails;
    legalEntityScreenDataFields = legalEntityScreenDataFields.filter((legalEntityScreenDataField: { ui_Field_Name: any; }) => (!_.includes(this.addScreenNegotiatedFields, legalEntityScreenDataField.ui_Field_Name)));

    // Check the mandatory requirement for Dependent fields
    this.caisServiceService.checkDependentFieldRequirement(this.LegalEntityDataDetails[objectIndex], legalEntityScreenDataFields, [{baseField: 'Role End Date', dependentField: 'Role End Reason', associatedFields: true}, {baseField: 'TID Type', baseFieldValues: this.caisServiceService.TIDTypes, dependentField: 'Foreign TID Type'}, {baseField: 'Foreign TID Type', baseFieldValues: this.caisServiceService.foreignTIDTypes, dependentField: 'Foreign TID Country'}, {baseField: 'Role', baseFieldValues: this.caisServiceService.customerDiscretionRoleTypes, dependentField: 'Has Discretion'}]);

    this.validateSingleObjectFormFields(objectIndex, this.LegalEntityDataDetails, legalEntityScreenDataFields);

    /* Check Role */
     this.validateRole(objectIndex, this.LegalEntityDataDetails);

    /* Check for TID existence */
      this.caisServiceService.checkTIDExistence(this.LegalEntityDataDetails[objectIndex], this.NaturalPersonDataDetails, this.LegalEntityDataDetails);

    /* Legal Entity Address Fields */
      if(this.LegalEntityAddressDetails.length > 0) {
        this.dataService.formAddressDetails(this.AddressGridColumns, this.LegalEntityDataDetails[objectIndex], this.LegalEntityAddressDetails[objectIndex]); // Assign Address Field Values
      }
      /* Legal Entity Address Validation */
        if(this.LegalEntityAddressDetails[objectIndex].length > 0) {
          let addressFields = this.AddressDetails;
          for(let i=0;i<this.LegalEntityAddressDetails[objectIndex].length;i++) {
            if((i==0 && !this.isEmptyObject(this.LegalEntityDataDetails[objectIndex])) || !this.isEmptyObject(this.LegalEntityAddressDetails[objectIndex][i])) {
              /* Previous Empty Address Fields Validation */
                this.previousEmptyAddressFieldValidation(i, this.LegalEntityAddressDetails[objectIndex], addressFields);
              /* End of Previous Empty Address Fields Validation */
              this.validateFields(this.LegalEntityAddressDetails[objectIndex][i], addressFields); // Validating Legal Entity Address Fields
            } else {
              delete this.LegalEntityAddressDetails[objectIndex][i].errorFields;
            }
          }
        }
        let LegalEntityAddressErrorArray = this.LegalEntityAddressDetails[objectIndex].filter((LegalEntityAddObj: { [x: string]: {}; }) => LegalEntityAddObj['errorFields'] && Object.keys(LegalEntityAddObj['errorFields']).length > 0);
      /* End of Legal Entity Address Validation */
    /* End of Legal Entity Address Fields */

    /* Stop Page submission while found Field error */
    if((this.LegalEntityDataDetails[objectIndex] && Object.keys(this.LegalEntityDataDetails[objectIndex].errorFields).length > 0) || LegalEntityAddressErrorArray.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  /* Validate Single Tab Form Data */
  validateSingleObjectFormFields(objectIndex: number, formData: string | any[], screenFields: string | any[]) {
    if(screenFields.length > 0) {
      for(let i=0; i<screenFields.length; i++) {
        for(let j=0; j<formData.length; j++) {
          if(objectIndex === j) {
            if(!formData[j]["errorFields"]) {
              formData[j]["errorFields"] = [];
            }
            /* Required Field Validation */
            if(screenFields[i]["isrequired"]===true && (!formData[j][screenFields[i].field_Name] || formData[j][screenFields[i].field_Name]==="" || formData[j][screenFields[i].field_Name]===null || (screenFields[i].datatype==='Array' && formData[j][screenFields[i].field_Name].length===0))) {
              formData[j]["errorFields"][screenFields[i].field_Name] = "Please enter required field";
              continue;
            } else if(screenFields[i]["isrequired"]===true && (formData[j][screenFields[i].field_Name] || formData[j][screenFields[i].field_Name]!=="" || formData[j][screenFields[i].field_Name]!==null)) {
              delete formData[j]["errorFields"][screenFields[i].field_Name];
            }
            /* Alternative Field Validation */
            this.checkAlterNativeField(formData[j], screenFields[i]);
            /* Field format Validation */
            if(this.caisServiceService.checkRegexpressionValidity(formData[j], screenFields[i])) {
              let validFieldFormat = false;
              for(let k=0; k<screenFields[i]["regexpressions"].length; k++) {
                if(new RegExp(screenFields[i]["regexpressions"][k]).test(formData[j][screenFields[i].field_Name])===true) {
                  validFieldFormat = true;
                  delete formData[j]["errorFields"][screenFields[i].field_Name];
                }
              }
              if(validFieldFormat === false) {
                formData[j]["errorFields"][screenFields[i].field_Name] = "Please enter valid format";
                continue;
              }
            }
          }
        }
      }
    }
  }

  checkAlterNativeField(formDataObj: any, screenField: any) {
    if(screenField["hasAlternativeField"]===true && screenField["isDisable"]!==true && (!formDataObj[screenField.field_Name] || formDataObj[screenField.field_Name]==="" || formDataObj[screenField.field_Name]===null)) {
      let hasAlternateValue = false;
      for(let k=0; k<screenField["alternativeFields"].length; k++) {
        if((formDataObj[screenField["alternativeFields"][k]] && formDataObj[screenField["alternativeFields"][k]]!==undefined)) {
          hasAlternateValue = true;
          break;
        }
      }
      if(!hasAlternateValue) {
        formDataObj["errorFields"][screenField['field_Name']] = "Please enter " + screenField['field_Name'] + " OR " + screenField["alternativeFields"].join();
      } else {
        delete formDataObj["errorFields"][screenField['field_Name']];
      }
    } else {
      delete formDataObj["errorFields"][screenField['field_Name']];
    }
  }

  /* Previous Empty Address Fields Validation */
  previousEmptyAddressFieldValidation(currentIndex: number, addressDataObj: { [x: string]: any; }, addressFields: any) {
    if(currentIndex > 0) {
      for(let j=currentIndex; j>=0; j--) {
        if(this.isEmptyObject(addressDataObj[j])) {
          this.validateFields(addressDataObj[j], addressFields); // Validating FDID Address Fields
        }
      }
    }
  }

  getFormat(dateObj: any) {
    return dateObj ? format(new Date(dateObj), 'yyyy-MM-dd') : '';
  }

  setTIDType(fieldName: any, index: number) {
    if(_.includes(['ein', 'lei'], fieldName)) {
      if((this.LegalEntityDataDetails[index]['ein'] || this.LegalEntityDataDetails[index]['lei']) && !this.LegalEntityDataDetails[index]['tidType']) {
        this.LegalEntityDataDetails[index]['tidType'] = 'EIN';
        /* Generate TID Value automatically on creation of Legal Entity */
        if(index===0 || (this.LegalEntityDataDetails[index]['tidUpdate']===this.caisServiceService.TIDUpdateStatuses[1] && this.LegalEntityDataDetails[index]['newlyCreated']==='Yes')) {
          this.AutoGenerateTID(this.LegalEntityDataDetails[index]['ein'], fieldName, index);
        }
      } else if(!this.LegalEntityDataDetails[index]['ein'] && !this.LegalEntityDataDetails[index]['lei'] && this.LegalEntityDataDetails[index]['tidType']==='EIN') {
        this.LegalEntityDataDetails[index]['tidType'] = null;
      }
    }
  }

  AutoGenerateTID(elemValue: any, fieldName: any, tabIndex: number) {
    if(tabIndex===0 || (this.LegalEntityDataDetails[tabIndex]['tidUpdate']===this.caisServiceService.TIDUpdateStatuses[1] && this.LegalEntityDataDetails[tabIndex]['newlyCreated']==='Yes')) {
      /* Auto TID Generation by EIN OR LEI Value when creating new Legal Entity */
      if(_.includes(['ein', 'tidType'], fieldName) && this.LegalEntityDataDetails[tabIndex]['tidType'] === 'EIN') {
        let legalEntityEinDataFields = this.LegalEntityScreenDataDetails;
        legalEntityEinDataFields = legalEntityEinDataFields.filter((screenDataField: { field_Name: string; }) => screenDataField.field_Name === 'ein');

        if(legalEntityEinDataFields[0]["regexpressions"] && legalEntityEinDataFields[0]["regexpressions"].length > 0) {
          for(let j=0; j<legalEntityEinDataFields[0]["regexpressions"].length; j++) {
            if(new RegExp(legalEntityEinDataFields[0]["regexpressions"][j]).test(this.LegalEntityDataDetails[tabIndex]['ein'])===true) {
              this.caisServiceService.TIDGenerator(this.LegalEntityDataDetails[tabIndex]['ein']).subscribe({
                next: (res:any) => {
                let resultSet: any = res;
                this.LegalEntityDataDetails[tabIndex]['tidValue'] = (resultSet.tidValue ? resultSet.tidValue : "");
              }});
              break;
            }
          }
        }
      } else if (_.includes(['lei', 'tidType', 'foreignTIDType'], fieldName) && !this.LegalEntityDataDetails[tabIndex]['ein'] && this.LegalEntityDataDetails[tabIndex]['lei'] !== '' && this.LegalEntityDataDetails[tabIndex]['tidType'] === 'FOREIGN' && this.LegalEntityDataDetails[tabIndex]['foreignTIDType'] === 'LEI') {
        this.caisServiceService.TIDGenerator(this.LegalEntityDataDetails[tabIndex]['lei']).subscribe({
          next: (res:any) => {
          let resultSet: any = res;
          this.LegalEntityDataDetails[tabIndex]['tidValue'] = (resultSet.tidValue ? resultSet.tidValue : "");
        }});
      }
    }
  }
  selectedCustomer(event:any){
    let searchIndex = this.selectedTabIndex!==0 && this.selectedTabIndex!==this.NaturalPersons.length ? true : false;
    if (searchIndex) {
      this.confirmationService.confirm({
        message: 'Do you want override details?',
        key: 'confirmationDialog',
        acceptLabel: 'Yes',
        acceptIcon:'pi pi-check',
        rejectLabel: 'No',
        rejectIcon:'pi pi-times',
        acceptButtonStyleClass: "confirm-dialog-button",
        rejectButtonStyleClass: "confirm-dialog-button",

        accept: () => {
          this.selectConfirmCustomer(event);
        }
      });
    }
    else {
      this.selectConfirmCustomer(event);
    }
  }

  /* Retrieve customer from Customer Search List */
  selectConfirmCustomer(customer: { [x: string]: any; }) {
    /* Prepare Customer Data */
    let customerDetails, customerAddressDetails;
    if (this.selectedCustomerType === this.constantService.customerTypes[0]) {
      customerDetails = this.NaturalPersonDataDetails;
      customerAddressDetails = this.NaturalPersonAddressDetails;
    } else if (this.selectedCustomerType === this.constantService.customerTypes[1]) {
      customerDetails = this.LegalEntityDataDetails;
      customerAddressDetails = this.LegalEntityAddressDetails;
    }
    if(this.FDIDScreenDataDetails.fdidEndDate && this.FDIDScreenDataDetails.fdidEndReason){
      this.FDIDScreenDataDetails.fdidEndDate ='';
      this.FDIDScreenDataDetails.fdidEndReason='';
    }
    /* Prepare Customer AddressData */
    let customerAddressData = [];
    if (!_.isEmpty(customer)) {
      for (let j = 1; j <= 4; j++) {
        customerAddressData.push({
          'addr_addrLine1': customer['addr' + j + '_addrLine1'],
          'addr_addrLine2': customer['addr' + j + '_addrLine2'],
          'addr_addrLine3': customer['addr' + j + '_addrLine3'],
          'addr_addrLine4': customer['addr' + j + '_addrLine4'],
          'addr_city': customer['addr' + j + '_city'],
          'addr_regionCode': customer['addr' + j + '_regionCode'],
          'addr_countryCode': customer['addr' + j + '_countryCode'],
          'addr_postalCode': customer['addr' + j + '_postalCode']
        });
      }
    }

    /* Shifting Data of selected Customer to the New Natural Person/Legal Entity Tab */
   if(this.selectedTabIndex >= this.NaturalPersons.length) {
      this.caisServiceService.searchCustomerIndex = this.selectedTabIndex - this.NaturalPersons.length;   
    }
    else{
      this.caisServiceService.searchCustomerIndex = this.selectedTabIndex;
    }
    customerDetails[this.caisServiceService.searchCustomerIndex] = customer;
    customerAddressDetails[this.caisServiceService.searchCustomerIndex] = customerAddressData;


    /* Customize UI Display Data */
    if(this.selectedCustomerType===this.constantService.customerTypes[0]) {
      /* Mask Birth Date Field */
      if(this.yearField.length > 0) {
        this.maskYear();
      }
    }
    /* Check for TID existence */
    this.caisServiceService.checkTIDExistence(customerDetails[0], this.NaturalPersonDataDetails, this.LegalEntityDataDetails);
  }

  removeLTID(rowIndex:any){
    this.LTIDDataSet.splice(rowIndex,1)
  }

  /* Open TID Update Popup */
  openTIDUpdate() {
    this.isClickOnTIDCorrection = false;
    this.isClickOnFDIDCorrection = false;
    let optedCustomerIndex;
    let tab={
      header:'',
    }
    let legalEntityTabIndex
    let naturalPersonTabIndex
    
    if(this.selectedTabIndex > this.NaturalPersons.length) {
      optedCustomerIndex = this.selectedTabIndex - this.NaturalPersons.length; // Identify current selected Legal Entity Tab Index
      legalEntityTabIndex = this.LegalEntities[optedCustomerIndex]['tabIndex'];
      for(let i = optedCustomerIndex+2; i< this.LegalEntities.length; i++){
        this.LegalEntities[i]['tabIndex'] +=1;
      }
      this.LegalEntities.splice((optedCustomerIndex+1), 0, {...this.LegalEntities[optedCustomerIndex],tabIndex:legalEntityTabIndex+1}); // Create Cloned Legal Entity from Original ones
      this.LegalEntityDataDetails.splice((optedCustomerIndex+1), 0, {...this.LegalEntityDataDetails[optedCustomerIndex]});
      this.LegalEntityAddressDetails.splice((optedCustomerIndex+1), 0, [...this.LegalEntityAddressDetails[optedCustomerIndex]]);
      this.LegalEntityDataDetails[optedCustomerIndex]['tidUpdate'] = this.caisServiceService.TIDUpdateStatuses[0]; // Add tidUpdate Flag to Original & Cloned Legal Entity [Actual - Original Cusotmer, Cloned - Cloned Customer]
      this.LegalEntityDataDetails[(optedCustomerIndex+1)]['tidUpdate'] = this.caisServiceService.TIDUpdateStatuses[1];
      this.LegalEntityDataDetails[(optedCustomerIndex+1)]['inCustomerRecordID'] = 'RSMS_' + this.LegalEntityDataDetails[optedCustomerIndex]['inCustomerRecordID'];
      this.LegalEntityDataDetails[(optedCustomerIndex+1)]['ein'] = this.LegalEntityDataDetails[(optedCustomerIndex+1)]['lei'] = this.LegalEntityDataDetails[(optedCustomerIndex+1)]['tidType'] = this.LegalEntityDataDetails[(optedCustomerIndex+1)]['foreignTIDType'] = this.LegalEntityDataDetails[(optedCustomerIndex+1)]['foreignTIDCountryCd'] = this.LegalEntityDataDetails[(optedCustomerIndex+1)]['replacedByTID'] = this.LegalEntityDataDetails[(optedCustomerIndex+1)]['replacedByTIDType'] = this.LegalEntityDataDetails[(optedCustomerIndex+1)]['replacingForeignTIDType'] = this.LegalEntityDataDetails[(optedCustomerIndex+1)]['replacingForeignTIDCountryCd'] = null;
      this.LegalEntityDataDetails[(optedCustomerIndex+1)]['tidValue'] = null; // Reset TID value from Cloned Legal Entity Object
      this.LegalEntityDataDetails[(optedCustomerIndex+1)]['newlyCreated'] = 'Yes';
      tab.header = this.LegalEntities[optedCustomerIndex].name; // Add Dynamically created Tab Header Name
    } else {
      optedCustomerIndex = this.selectedTabIndex; // Identify current selected Natural Person Tab Index
      naturalPersonTabIndex = this.NaturalPersons[optedCustomerIndex]['tabIndex'];
      this.NaturalPersons.splice((optedCustomerIndex+1), 0, {...this.NaturalPersons[optedCustomerIndex],tabIndex:naturalPersonTabIndex+1}); // Create Cloned Natural Person from Original ones
      for(let i = optedCustomerIndex+2; i< this.NaturalPersons.length; i++){
        this.NaturalPersons[i]['tabIndex'] +=1;
      }
      for (let i = 0; i < this.LegalEntities.length; i++) {
        if (this.LegalEntities[i]['tabIndex'] > this.selectedTabIndex) {
          this.LegalEntities[i]['tabIndex'] += 1;
        }
      }
      this.NaturalPersonDataDetails.splice((optedCustomerIndex+1), 0, {...this.NaturalPersonDataDetails[optedCustomerIndex]});
      this.NaturalPersonAddressDetails.splice((optedCustomerIndex+1), 0, [...this.NaturalPersonAddressDetails[optedCustomerIndex]]);
      this.NaturalPersonDataDetails[optedCustomerIndex]['tidUpdate'] = this.caisServiceService.TIDUpdateStatuses[0]; // Add tidUpdate Flag to Original & Cloned Natural Person [Actual - Original Cusotmer, Cloned - Cloned Customer]
      this.NaturalPersonDataDetails[(optedCustomerIndex+1)]['tidUpdate'] = this.caisServiceService.TIDUpdateStatuses[1];
      this.NaturalPersonDataDetails[(optedCustomerIndex+1)]['inCustomerRecordID'] = 'RSMS_' + this.NaturalPersonDataDetails[optedCustomerIndex]['inCustomerRecordID'];
      this.NaturalPersonDataDetails[(optedCustomerIndex+1)]['tidType'] = this.NaturalPersonDataDetails[(optedCustomerIndex+1)]['foreignTIDType'] = this.NaturalPersonDataDetails[(optedCustomerIndex+1)]['foreignTIDCountryCd'] = this.NaturalPersonDataDetails[(optedCustomerIndex+1)]['replacedByTID'] = this.NaturalPersonDataDetails[(optedCustomerIndex+1)]['replacedByTIDType'] = this.NaturalPersonDataDetails[(optedCustomerIndex+1)]['replacingForeignTIDType'] = this.NaturalPersonDataDetails[(optedCustomerIndex+1)]['replacingForeignTIDCountryCd'] = null;
      this.NaturalPersonDataDetails[(optedCustomerIndex+1)]['tidValue'] = null; // Reset TID value from Cloned Natural Person Object
      this.NaturalPersonDataDetails[(optedCustomerIndex+1)]['newlyCreated'] = 'Yes';
      tab.header = this.NaturalPersons[optedCustomerIndex].name; // Add Dynamically created Tab Header Name
      /* Mask Birth Date Field */
      if(this.yearField.length > 0) {
        this.maskYear();
      }
    }
    this.tabs.splice((this.selectedTabIndex+1), 0, tab); // Add New Tab in Prime NG Tab-View
    this.TIDUpdatedTabIndexes.push(this.selectedTabIndex, (this.selectedTabIndex+1)); // Include Original & Clone Tab Indexes in TID Update Tab Indexes Array
    this.selectedTabIndex = (this.selectedTabIndex + 1);
    this.getSearchCustomerType(); // Receive Customer Type for Customer Search on the basis of Opted Tab Index
  }

  copyAddress(rowdata: any, index: number, isNaturalPerson: boolean, personIndex: number) {
    if (isNaturalPerson) {
      this.NaturalPersonAddressDetails[personIndex][index] = [];
      this.NaturalPersonAddressDetails[personIndex][index]["addr_addrLine1"] = rowdata.addr_addrLine1;
      this.NaturalPersonAddressDetails[personIndex][index]["addr_addrLine2"] = rowdata.addr_addrLine2;
      this.NaturalPersonAddressDetails[personIndex][index]["addr_addrLine3"] = rowdata.addr_addrLine3;
      this.NaturalPersonAddressDetails[personIndex][index]["addr_addrLine4"] = rowdata.addr_addrLine4;
      this.NaturalPersonAddressDetails[personIndex][index]["addr_city"] = rowdata.addr_city;
      this.NaturalPersonAddressDetails[personIndex][index]["addr_regionCode"] = rowdata.addr_regionCode;
      this.NaturalPersonAddressDetails[personIndex][index]["addr_countryCode"] = rowdata.addr_countryCode;
      this.NaturalPersonAddressDetails[personIndex][index]["addr_postalCode"] = rowdata.addr_postalCode;
    } else {
      this.LegalEntityAddressDetails[personIndex][index] = [];
      this.LegalEntityAddressDetails[personIndex][index]["addr_addrLine1"] = rowdata.addr_addrLine1;
      this.LegalEntityAddressDetails[personIndex][index]["addr_addrLine2"] = rowdata.addr_addrLine2;
      this.LegalEntityAddressDetails[personIndex][index]["addr_addrLine3"] = rowdata.addr_addrLine3;
      this.LegalEntityAddressDetails[personIndex][index]["addr_addrLine4"] = rowdata.addr_addrLine4;
      this.LegalEntityAddressDetails[personIndex][index]["addr_city"] = rowdata.addr_city;
      this.LegalEntityAddressDetails[personIndex][index]["addr_regionCode"] = rowdata.addr_regionCode;
      this.LegalEntityAddressDetails[personIndex][index]["addr_countryCode"] = rowdata.addr_countryCode;
      this.LegalEntityAddressDetails[personIndex][index]["addr_postalCode"] = rowdata.addr_postalCode;
    }
  }
  TIDCorrectionConfirmation(){
    this.sharedHttpClientService.get(
      this.urlService.setAPIURl(
        APIURL.CAIS_FDID_FINRA_Status+'/'+this.rowDataforDialog["firmDesignatedID"]
      ), 
    ).subscribe({
      next: (data:any) => {
        if(data.finraStatus =='ACCEPTED'){
        this.confirmationService.confirm({
          message: 'FDID/Customer is finra accepted, do you still want to do correction and not update TID?',
          key: 'confirmationDialog',
          acceptLabel: 'Yes',
           acceptIcon:'pi pi-check',
          rejectLabel: 'No',
          rejectIcon:'pi pi-times',
          acceptButtonStyleClass:"confirm-dialog-button",
          rejectButtonStyleClass:"confirm-dialog-button",
          
          accept: () => {
            this.setValuesForTIDCorrection();
          }
        });
      }
      else{
        this.setValuesForTIDCorrection();
      }
     
        }, error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
    }});
  }
  setValuesForTIDCorrection(){
    this.isClickOnTIDCorrection = true;
    let optedCustomerIndex;
    
    if(this.selectedTabIndex > this.NaturalPersons.length) {
      optedCustomerIndex = this.selectedTabIndex - this.NaturalPersons.length;
      this.LETIDSwitches[optedCustomerIndex] = false;
      this.LegalEntityDataDetails[optedCustomerIndex]['priorTidValue'] = this.LegalEntityDataDetails[optedCustomerIndex]['tidValue'];
      this.LegalEntityDataDetails[optedCustomerIndex]['action'] = 'CORRECTION';
      this.LegalEntityDataDetails[optedCustomerIndex]['tidUpdate'] = this.caisServiceService.TIDUpdateStatuses[1];
      this.LegalEntityDataDetails[optedCustomerIndex]['newlyCreated'] = 'Yes';
      this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_INFO, summary: this.constantService.MESSAGE_SEVERITY_INFO, detail: ' Please update TID value' });

    } else {
      optedCustomerIndex = this.selectedTabIndex;
      this.NPTIDSwitches[optedCustomerIndex] = false;
      this.NaturalPersonDataDetails[optedCustomerIndex]['priorTidValue'] =  this.NaturalPersonDataDetails[optedCustomerIndex]['tidValue'];
      this.NaturalPersonDataDetails[optedCustomerIndex]['action'] = 'CORRECTION';     
      this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_INFO, summary: this.constantService.MESSAGE_SEVERITY_INFO, detail: ' Please update TID value' });

    }
    
  }

  populateLegalName(){
      if(this.LegalEntityDataDetails.length > 0) { 
        this.LegalEntityDataDetails[0]['legalName'] = this.FDIDScreenDataDetails['accountName'] && this.FDIDScreenDataDetails['accountName'].trim();
      }
  }

  openTIDGenrator(){
    this.caisServiceService.isDisplayTIDGenerator = true;
    this.caisServiceService.isLegalEntityForeignTIDGenerator = false; 
    this.caisServiceService.isNaturalPersonForeignTIDGenerator = false;
  }

  changeReceivedFDID(field:any) {
     this.sharedHttpClientService.get(
      this.urlService.setAPIURl(
        APIURL.CAIS_FDID_FINRA_Status+'/'+this.rowDataforDialog["firmDesignatedID"]
      ), 
    ).subscribe({
      next: (data:any) => {
        if(data.finraStatus !== 'SUBMITTED'){
        this.confirmationService.confirm({
          message: 'Do you want to correct FDID?',
          key: 'confirmationDialog',
          acceptLabel: 'Yes',
          acceptIcon:'pi pi-check',
          rejectLabel: 'No',
          rejectIcon:'pi pi-times',
          acceptButtonStyleClass:"confirm-dialog-button",
          rejectButtonStyleClass:"confirm-dialog-button",
          
          accept: () => {
            this.isClickOnFDIDCorrection =true;
            field.isDisable = false;

          },
          reject: () => {
            this.isClickOnFDIDCorrection =false;
            field.isDisable = true;
          }
        });
      }
      else{
        this.messageService.add({ severity: 'info', summary: 'Record', detail: "It's already submitted" });
        this.isClickOnFDIDCorrection =false;
        field.isDisable = true;
      }
     
        }, error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
    }});
  }
  copyDetails(FDIDrowdata: any,index:any) {
    this.isCopyRecord = true;    
    this.getScreenData(FDIDrowdata);
    this.Add = true;
    this.dataService.roeSelectedRecords[0] = (FDIDrowdata);
    this.rowDataforDialog = FDIDrowdata;
    this.rowIndexForDialog = index;
    this.getEditAdditionalData();
  }
  getTabIndex(){
    return this.NaturalPersons.length + this.LegalEntities.length + 1;
  }

  /* Apply Generated TID Value for NaturalPaerson | LegalEntity */
  applyTIDValue(userType: any, objectIndex: number) {
    if(userType==='NaturalPerson') {
      this.caisServiceService.currentNaturalPersonTIDValue.subscribe(tidValue=>{
        this.NaturalPersonDataDetails[objectIndex]['tidValue'] = tidValue;
      });
    } else if(userType==='LegalEntity') {
      this.caisServiceService.currentLegalEntityTIDValue.subscribe(tidValue=>{
        this.LegalEntityDataDetails[objectIndex]['tidValue'] = tidValue;
      });
    }
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
  
}